<div class="container bg-light position-relative app-participant-detail">
    <div class="row bg-white p-0">
        <!-- Col Left -->
        <div class="col-lg-8 bg-white pl-0 pr-0" [ngClass]="parentClass" style="position: relative">
            <!-- <div class="app-share-button app-cursor" (click)="shbClick($event);" [class.app-share-button--active]="shareBtnAct">
                 <svg class="icon fa-share-alt"><use href="#icon-share"/></svg>
                <div class="app-share-button__links app-share-button__links--alternate">
                     <app-shared-buttons [max]="sharedMax"></app-shared-buttons>
                </div>
            </div> -->
            <ng-container *ngIf="data as participant; else elseBlock">
                <div *ngIf="loadedError" class="pb-6">
                    <div class="tab-pane" id="tab3-content" role="tabpanel" aria-labelledby="tab3">
                        <div class="text-center pt-7">
                            <svg class="icon icon--64 mb-4">
                                <use [attr.xlink:href]="'#icon-' + sportName" />
                            </svg>
                            <h4 class="font-weight-bold">{{ 'web.we_are_sorry' | translate }}</h4>
                            <p class="mb-6">{{ 'web.error_data_load' | translate }}</p>
                        </div>
                    </div>
                </div>

                <div class="pl-5 pt-5 pr-5 pr-md-3 pb-3 app-participant-detail__info">
                    <div class="row">
                        <div class="col-md-10">
                            <div class="media">
                                <div class="img-circle img-circle--100 mr-3 rounded-circle">
                                    <img
                                        [src]="cdn + participant.image | responsive: 'participant' : 'large'"
                                        [attr.alt]="participant.name"
                                        class="app-participant-logo"
                                        height="100"
                                        width="100"
                                    />
                                </div>
                                <div class="media-body">
                                    <div class="d-flex icon-wrappe r justify-content-start flex-wrap">
                                        <h1 class="mb-2 mr-3" data-cy="participant-name">
                                            {{ participant.name }}
                                            <app-favorite [participantId]="data.id" [type]="'participant'">
                                                <span notactive>{{
                                                    'web.add_participant_to_favorites' | translate
                                                }}</span>
                                                <span active>{{
                                                    'web.remove_participant_from_favorites' | translate
                                                }}</span>
                                            </app-favorite>
                                            <div
                                                *ngIf="hasWinLoseStats"
                                                class="app-fighter-bilance d-flex flex-wrap flex-md-nowrap"
                                            >
                                                <div
                                                    class="app-fighter-bilance__item app-fighter-bilance--win d-flex flex-nowrap justify-content-between"
                                                >
                                                    <div>{{ 'web.participant_record_win' | translate }}</div>
                                                    <div>{{ participantRecord[0] }}</div>
                                                </div>
                                                <div
                                                    class="app-fighter-bilance__item app-fighter-bilance--lose d-flex flex-nowrap justify-content-between"
                                                >
                                                    <div>{{ 'web.participant_record_lose' | translate }}</div>
                                                    <div>{{ participantRecord[1] }}</div>
                                                </div>
                                                <div
                                                    class="app-fighter-bilance__item app-fighter-bilance--draw d-flex flex-nowrap justify-content-between"
                                                >
                                                    <div>{{ 'web.participant_record_draw' | translate }}</div>
                                                    <div>{{ participantRecord[2] }}</div>
                                                </div>
                                            </div>
                                        </h1>
                                        <img
                                            *ngIf="participant.country_flag"
                                            class="mr-3 mb-2"
                                            [src]="cdn + participant.country_flag"
                                            [attr.alt]=""
                                            height="35"
                                        />
                                        <div class="break-md"></div>
                                        <div class="mb-3 mb-lg-0">
                                            <ng-container>
                                                <app-last-matches
                                                    [limit]="6"
                                                    [matches]="formReverse"
                                                ></app-last-matches>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div
                                        class="mb-2 h5 d-flex"
                                        *ngIf="participant.tournament && participant.tournament.length > 0"
                                    >
                                        <span *ngIf="!isTennis" class="font-weight-bold mr-1">
                                            <a
                                                [routerLink]="[
                                                    '/page/sport/event',
                                                    sportName + '-' + sportId,
                                                    participant.tournament[0]?.tournament_id,
                                                ]"
                                                class="text-reset"
                                            >
                                                {{ participant.tournament[0].sub_tournament_name }}</a
                                            >
                                        </span>
                                        <span>({{ participant.tournament[0].category_name }})</span>
                                        <!-- <div class="img-circle img-circle--20 ml-2 rounded-circle">
                                <img src="img/flags/4x3/es.svg" alt="Flag of Spain" height="20">
                              </div> -->
                                    </div>
                                    <div>
                                        <a
                                            *ngFor="let t of uniqueTournaments; trackBy: trackByIndex"
                                            class="crumb-inline crumb-inline__link"
                                            [routerLink]="['/page/sport/event/', sportName + '-' + sportId, t.id]"
                                            >{{ t.name }}</a
                                        >
                                    </div>

                                    <div class="ng-star-inserted" *ngIf="participant.venue">
                                        <span class="ng-star-inserted" *ngIf="participant.venue?.stadium">
                                            <span class="text-gray">{{ 'web.home_stadium' | translate }}:</span>
                                            {{ participant.venue?.stadium }}
                                            <ng-container *ngIf="participant.venue.place">
                                                ({{ participant.venue.place }})
                                            </ng-container>
                                            <ng-container *ngIf="client.use('map') && participant.venue.stadium_coords">
                                                -
                                                <a class="link ext-link app-cursor" (click)="map = !map"
                                                    >{{ 'web.map' | translate }} &nbsp;</a
                                                >
                                            </ng-container>
                                        </span>
                                        <span class="ng-star-inserted" *ngIf="participant.venue?.stadium_capacity">
                                            <span class="text-gray"
                                                >{{ 'web.home_stadium_capacity' | translate }}:</span
                                            >
                                            {{ participant.venue?.stadium_capacity | appnumber }}
                                        </span>
                                        <span class="ng-star-inserted" *ngIf="participant.state">
                                            <br />
                                            <span class="text-gray">{{ 'web.state' | translate }}:</span>
                                            {{ 'web.state_' + participant.state | lowercase | translate }}
                                        </span>
                                    </div>

                                    <div class="text-gray">
                                        <table>
                                            <tr *ngIf="rankingStats">
                                                <td class="pr-lg-4">
                                                    <div class="d-block d-md-inline app-word-nowrap">
                                                        {{ rankingStats.translation | translate }}
                                                        <span class="font-weight-bold text-body">
                                                            <br />
                                                            #{{ rankingStats.value }}
                                                        </span>
                                                        <span class="px-2"></span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr *ngIf="participant.tennis_rankings_single != 0">
                                                <td class="pr-lg-4">
                                                    <div class="d-block d-md-inline app-word-nowrap">
                                                        <ng-container *ngIf="participant.tennis_rankings_single != null"
                                                            >{{ 'web.tennis_single_rainking' | translate }}
                                                            <span class="font-weight-bold text-body">
                                                                <br />
                                                                #{{ participant.tennis_rankings_single }}
                                                            </span>
                                                            <ng-container
                                                                *ngIf="+participant.tennis_movement_single != 0"
                                                            >
                                                                <svg
                                                                    *ngIf="+participant.tennis_movement_single > 0"
                                                                    class="icon icon--8 icon--success ml-2"
                                                                >
                                                                    <use xlink:href="#icon-arrow-up"></use>
                                                                </svg>
                                                                <svg
                                                                    *ngIf="+participant.tennis_movement_single < 0"
                                                                    class="icon icon--8 icon--danger ml-2"
                                                                >
                                                                    <use xlink:href="#icon-arrow-down"></use>
                                                                </svg>
                                                                &nbsp;<small
                                                                    [class.text-success]="
                                                                        +participant.tennis_movement_single > 0
                                                                    "
                                                                    [class.text-danger]="
                                                                        +participant.tennis_movement_single < 0
                                                                    "
                                                                    >{{ participant.tennis_movement_single }}</small
                                                                >
                                                            </ng-container>
                                                            <span class="px-2"></span>
                                                        </ng-container>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-block d-md-inline app-word-nowrap">
                                                        <ng-container *ngIf="participant.tennis_points_single != null">
                                                            {{ 'web.tennis_single_points' | translate }}
                                                            <span class="font-weight-bold text-body">
                                                                <br />
                                                                {{ participant.tennis_points_single }}</span
                                                            >
                                                            <span class="px-2"></span
                                                        ></ng-container>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr *ngIf="participant.tennis_rankings_double != 0">
                                                <td>
                                                    <div class="d-block d-md-inline app-word-nowrap">
                                                        <ng-container *ngIf="participant.tennis_rankings_double != null"
                                                            >{{ 'web.tennis_double_rainking' | translate }}
                                                            <span class="font-weight-bold text-body">
                                                                <br />#{{ participant.tennis_rankings_double }}</span
                                                            >
                                                            <ng-container
                                                                *ngIf="+participant.tennis_movement_double != 0"
                                                            >
                                                                <svg
                                                                    *ngIf="+participant.tennis_movement_double > 0"
                                                                    class="icon icon--8 icon--success ml-2"
                                                                >
                                                                    <use xlink:href="#icon-arrow-up"></use>
                                                                </svg>
                                                                <svg
                                                                    *ngIf="+participant.tennis_movement_double < 0"
                                                                    class="icon icon--8 icon--danger ml-2"
                                                                >
                                                                    <use xlink:href="#icon-arrow-down"></use>
                                                                </svg>
                                                                &nbsp;<small
                                                                    [class.text-success]="
                                                                        +participant.tennis_movement_double > 0
                                                                    "
                                                                    [class.text-danger]="
                                                                        +participant.tennis_movement_double < 0
                                                                    "
                                                                    >{{ participant.tennis_movement_double }}</small
                                                                >
                                                            </ng-container>
                                                            <span class="px-2"></span>
                                                        </ng-container>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-block d-md-inline app-word-nowrap">
                                                        <ng-container *ngIf="participant.tennis_points_double != null">
                                                            {{ 'web.tennis_double_points' | translate }}
                                                            <span class="font-weight-bold text-body">
                                                                <br />{{ participant.tennis_points_double }}</span
                                                            >
                                                            <span class="px-2"></span
                                                        ></ng-container>
                                                    </div>
                                                </td>
                                            </tr>

                                            <ng-container *ngIf="participant.rankings">
                                                <ng-container
                                                    *ngFor="let ranking of participant.rankings; trackBy: trackByIndex"
                                                >
                                                    <tr>
                                                        <td class="pr-lg-4" colspan="2">
                                                            <div class="d-block d-md-inline">
                                                                <ng-container *ngIf="ranking.rank != null">
                                                                    <div *ngIf="ranking.name" class="cell__overflow">
                                                                        {{
                                                                            'web.ranking-name-' +
                                                                                (ranking.name | slugify) | translate
                                                                        }}
                                                                    </div>
                                                                    <span class="font-weight-bold text-body">
                                                                        #{{ ranking.rank }}
                                                                    </span>
                                                                    <ng-container *ngIf="ranking.prize_money != null">
                                                                        {{ 'web.prize-money' | translate }}:
                                                                        <span class="font-weight-bold text-body">
                                                                            {{
                                                                                ranking.prize_money
                                                                                    | localeCurrency: 'GBP'
                                                                            }}</span
                                                                        >
                                                                        <br />
                                                                        <span class="px-2"></span
                                                                    ></ng-container>
                                                                    <ng-container *ngIf="+ranking.movement != 0">
                                                                        <svg
                                                                            *ngIf="+ranking.movement > 0"
                                                                            class="icon icon--8 icon--success ml-2"
                                                                        >
                                                                            <use xlink:href="#icon-arrow-up"></use>
                                                                        </svg>
                                                                        <svg
                                                                            *ngIf="+ranking.movement < 0"
                                                                            class="icon icon--8 icon--danger ml-2"
                                                                        >
                                                                            <use xlink:href="#icon-arrow-down"></use>
                                                                        </svg>
                                                                        &nbsp;<small
                                                                            [class.text-success]="+ranking.movement > 0"
                                                                            [class.text-danger]="+ranking.movement < 0"
                                                                            >{{ ranking.movement }}</small
                                                                        >
                                                                    </ng-container>
                                                                    <span class="px-2"></span>
                                                                </ng-container>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </ng-container>

                                                <tr
                                                    *ngIf="
                                                        participant.birthplace &&
                                                        participant.birthplace.country &&
                                                        participant.birthplace.city
                                                    "
                                                >
                                                    <td>
                                                        <div class="d-block d-md-inline app-word-nowrap">
                                                            {{ 'web.birthplace_country' | translate }}
                                                            <br />
                                                            <span class="font-weight-bold text-body">
                                                                {{ participant.birthplace.country }}</span
                                                            >
                                                            <span class="px-2"></span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="d-block d-md-inline app-word-nowrap">
                                                            {{ 'web.birthplace_city' | translate }}
                                                            <br />
                                                            <span class="font-weight-bold text-body">
                                                                {{ participant.birthplace.city }}</span
                                                            >
                                                            <span class="px-2"></span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="participant.meta?.main && participant.meta?.main?.length > 0"
                                            >
                                                <ng-container *ngFor="let pData of metaMain; trackBy: trackByIndex">
                                                    <tr>
                                                        <ng-container *ngFor="let row of pData; trackBy: trackByIndex">
                                                            <td valign="top" class="pr-lg-4">
                                                                <span class="app-word-nowrap text-gray">
                                                                    {{ row.translation | translate }}:
                                                                </span>
                                                                <br />
                                                                <div
                                                                    class="d-block d-md-inline font-weight-bold text-body"
                                                                >
                                                                    <ng-container [ngSwitch]="row.name">
                                                                        <ng-container *ngSwitchCase="'birthdate'">
                                                                            {{ row.value | livDate: 'birthdate' }} ({{
                                                                                row.value | livDate: 'age'
                                                                            }}
                                                                            {{
                                                                                'web.years-old' | translate | transinit
                                                                            }})
                                                                        </ng-container>
                                                                        <ng-container *ngSwitchCase="'dominant-hand'">
                                                                            {{ row.value | translate }}
                                                                        </ng-container>

                                                                        <ng-container *ngSwitchDefault>
                                                                            {{ row.value }}
                                                                        </ng-container>
                                                                    </ng-container>

                                                                    <!-- <ng-container *ngIf="row.type === 'birthdate'">
                                                            {{ row.value | livDate: 'birthdate' }} ({{
                                                                row.value | livDate: 'age'
                                                            }}
                                                            {{ 'web.years-old' | translate | transinit }})
                                                        </ng-container>

                                                        <ng-container *ngIf="row.type !== 'birthdate'">{{
                                                            row.value
                                                        }}</ng-container> -->
                                                                </div>
                                                            </td>
                                                        </ng-container>
                                                    </tr>
                                                </ng-container>
                                            </ng-container>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-md-2 text-md-right mt-2 mt-md-auto shared-btn-parent"
                            *ngIf="client.use('share')"
                        >
                            <div class="d-flex flex-row-reverse flex-md-column align-items-end">
                                <div class="dropdown ml-3 mb-md-2 dropdown-share">
                                    <button
                                        class="btn btn-light dropdown-share-btn"
                                        (click)="shbClick($event)"
                                        [class.app-share-button--active]="shareBtnAct"
                                        type="button"
                                        id="dropdown-share-btn"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <svg class="icon">
                                            <use xlink:href="#icon-share" />
                                        </svg>
                                        <div class="app-share-button__links app-share-button__links--alternate">
                                            <app-shared-buttons [max]="sharedMax"></app-shared-buttons>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="app-share-button app-cursor" (click)="shbClick($event);" [class.app-share-button--active]="shareBtnAct">
                         <svg class="icon fa-share-alt"><use href="#icon-share"/></svg>
                        <div class="app-share-button__links app-share-button__links--alternate">
                             <app-shared-buttons [max]="sharedMax"></app-shared-buttons>
                        </div>
                    </div> -->
                    </div>
                </div>

                <div class="nav-wrapper app-participant-detail__nav" style="position: relative">
                    <!-- <div class="app-mob-nav-shadow"></div> -->
                    <button
                        class="tabs-scroll-btn tabs-scroll-btn--prev"
                        [class.tabs-scroll-btn--visible]="canScrollLeft"
                        (click)="scrollTabs('left')"
                        aria-label="Scroll tabs left"
                    >
                        <span class="prev"></span>
                    </button>
                    <ul
                        #tabsList
                        class="nav nav-tabs font-weight-bold pt-0"
                        id="tabs-left"
                        role="tablist"
                        (scroll)="onTabsScroll()"
                    >
                        <li class="nav-item">
                            <a
                                class="nav-link active px-3 px-md-5"
                                [class.active]="activeTab == 1"
                                id="tab1"
                                data-toggle="tab"
                                href="#tab1-content"
                                (click)="activeTabFce(1)"
                                [routerLink]="['./']"
                                fragment="overview"
                                role="tab"
                                aria-controls="tab1-content"
                                aria-selected="true"
                                >{{ 'web.overview' | translate | transinit }}</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="finished"
                                [class.active]="activeTab == 2"
                                id="tab2"
                                data-toggle="tab"
                                href="#tab2-content"
                                [routerLink]="['./']"
                                fragment="results"
                                role="tab"
                                (click)="activeTabFce(2)"
                                aria-controls="tab2-content"
                                aria-selected="false"
                                >{{ 'web.finished_matches' | renamesportnav: sportName | translate | transinit }}</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="future_matches"
                                [class.active]="activeTab == 3"
                                id="tab3"
                                data-toggle="tab"
                                href="#tab3-content"
                                [routerLink]="['./']"
                                fragment="future"
                                role="tab"
                                (click)="activeTabFce(3)"
                                aria-controls="tab3-content"
                                aria-selected="false"
                                >{{ 'web.future_matches' | renamesportnav: sportName | translate | transinit }}</a
                            >
                        </li>
                        <li class="nav-item" *ngIf="participant.players.length > 0">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="players"
                                [class.active]="activeTab == 4"
                                id="tab4"
                                data-toggle="tab"
                                href="#tab4-content"
                                [routerLink]="['./']"
                                fragment="players"
                                role="tab"
                                (click)="activeTabFce(4)"
                                aria-controls="tab4-content"
                                aria-selected="false"
                                >{{ 'web.players' | translate | transinit }}</a
                            >
                        </li>
                        <li class="nav-item" *ngIf="participant?.meta?.basic && participant.meta!.basic!.length > 0">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="basic"
                                [class.active]="activeTab == 5"
                                id="tab5"
                                data-toggle="tab"
                                href="#tab5-content"
                                role="tab"
                                (click)="activeTabFce(5)"
                                aria-controls="tab5-content"
                                aria-selected="false"
                                >{{ 'web.basic' | translate | transinit }}</a
                            >
                        </li>
                        <li
                            class="nav-item"
                            *ngIf="
                                participant?.players_transfers &&
                                participant.players_transfers!.length > 0 &&
                                displayTransfers
                            "
                        >
                            <a
                                class="nav-link px-3 px-md-4"
                                [class.active]="activeTab == 7"
                                id="tab7"
                                data-toggle="tab"
                                href="#players-transfers"
                                [routerLink]="['./']"
                                fragment="players-transfers"
                                role="tab"
                                (click)="activeTabFce(7)"
                                aria-controls="tab7-content"
                                aria-selected="false"
                                >{{ 'web.players-transfers' | translate | transinit }}</a
                            >
                        </li>
                        <li class="nav-item" *ngIf="hasInfo && deviceService.isMobile()">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="info"
                                [class.active]="activeTab == 11"
                                id="tab11"
                                data-toggle="tab"
                                href="#tab11-content"
                                role="tab"
                                (click)="activeTabFce(11)"
                                aria-controls="tab11-content"
                                aria-selected="false"
                                >{{ 'web.participant_info' | translate | transinit }}</a
                            >
                        </li>
                        <li
                            class="nav-item"
                            *ngIf="participant?.meta?.statistics && participant.meta!.statistics!.length > 0"
                        >
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="stats"
                                [class.active]="activeTab == 6"
                                id="tab6"
                                data-toggle="tab"
                                href="#tab6-content"
                                role="tab"
                                (click)="activeTabFce(6)"
                                aria-controls="tab6-content"
                                aria-selected="false"
                                >{{ 'web.statistics' | translate | transinit }}</a
                            >
                        </li>
                        <!-- <li class="nav-item" *ngIf="participant.news?.length > 0 && client.use('news')">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="news"
                                [class.active]="activeTab == 7"
                                id="tab7"
                                data-toggle="tab"
                                href="#tab7-content"
                                [routerLink]="['./']"
                                fragment="news"
                                role="tab"
                                (click)="activeTabFce(7)"
                                aria-controls="tab7-content"
                                aria-selected="false"
                                >{{ 'web.news' | translate | transinit }}</a
                            >
                        </li>-->
                        <li class="nav-item" *ngIf="isTennis && participant.balance && participant.balance.length > 0">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="tennisBilance"
                                [class.active]="activeTab == 8"
                                id="tab8"
                                data-toggle="tab"
                                href="#tab8-content"
                                [routerLink]="['./']"
                                fragment="tennis_bilance"
                                role="tab"
                                (click)="activeTabFce(8)"
                                aria-controls="tab8-content"
                                aria-selected="false"
                                >{{ 'web.tennis_bilance' | translate | transinit }}</a
                            >
                        </li>
                        <!-- <li class="nav-item" *ngIf="deviceService.isMobile() && lang.isActiveDefault()">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="did_you_know"
                                [class.active]="activeTab == 10"
                                id="tab8"
                                data-toggle="tab"
                                href="#tab10-content"
                                role="tab"
                                (click)="activeTabFce(10)"
                                aria-controls="tab8-content"
                                aria-selected="false"
                                >{{ 'web.did_you_know' | translate | transinit }}</a
                            >
                        </li> -->
                        <li *ngIf="hasStats" class="nav-item">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="participantStats"
                                [class.active]="activeTab == 9"
                                id="tab8"
                                data-toggle="tab"
                                href="#tab9-content"
                                role="tab"
                                (click)="activeTabFce(9)"
                                aria-controls="tab9-content"
                                aria-selected="false"
                                >{{ 'web.participant_stats' | translate | transinit }}</a
                            >
                        </li>
                        <li *ngIf="hasFaceoffs()" class="nav-item">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="faceoffs"
                                [class.active]="activeTab == 14"
                                id="tab14"
                                data-toggle="tab"
                                href="#tab14-content"
                                role="tab"
                                (click)="activeTabFce(14)"
                                aria-controls="tab14-content"
                                aria-selected="false"
                                >{{ 'web.faceoffs' | translate | transinit }}</a
                            >
                        </li>
                        <li *ngIf="hasOptaStats" class="nav-item">
                            <a
                                class="nav-link px-3 px-md-5"
                                data-cy="participantExpectedGoals"
                                [class.active]="activeTab == 12"
                                id="tab8"
                                data-toggle="tab"
                                href="#tab12-content"
                                role="tab"
                                (click)="activeTabFce(12)"
                                aria-controls="tab12-content"
                                aria-selected="false"
                                >{{ 'web.expected_goals_season_tab' | translate }}</a
                            >
                        </li>
                        <li *ngIf="hasInjuries()" class="nav-item">
                            <a
                                class="nav-link active px-3 px-md-5"
                                [class.active]="activeTab == 13"
                                id="tab13"
                                data-toggle="tab"
                                href="#tab13-content"
                                (click)="activeTabFce(13)"
                                [routerLink]="['./']"
                                fragment="injuries"
                                role="tab"
                                aria-controls="tab13-content"
                                aria-selected="true"
                                >{{ 'web.injuries' | translate | transinit }}</a
                            >
                        </li>
                    </ul>
                    <button
                        class="tabs-scroll-btn tabs-scroll-btn--next"
                        [class.tabs-scroll-btn--visible]="canScrollRight"
                        (click)="scrollTabs('right')"
                        aria-label="Scroll tabs right"
                    >
                        <span class="next"></span>
                    </button>
                </div>
                <div class="tab-content bg-white px-0 px-lg-3 py-3 position-relative">
                    <div
                        class="tab-pane active"
                        [class.active]="activeTab == 1"
                        id="tab1-content"
                        role="tabpanel"
                        aria-labelledby="tab1"
                    >
                        <!--Live matches-->
                        <ng-container *ngIf="participant?.data?.live && participant.data!.live.length > 0">
                            <h6
                                class="table-sport__head bg-dark app-text-dark-tournament bg-primary--light"
                                data-toggle="collapse"
                                data-target="#collapse-1-live"
                                role="button"
                                aria-expanded="true"
                                aria-controls="collapse-today"
                            >
                                <span class="table-sport__head__text app-text-dark-tournament">{{
                                    'web.live_matches' | translate
                                }}</span>
                            </h6>
                            <div class="collapse show" id="collapse-1-live">
                                <app-component-match
                                    *ngFor="let match of participant.data.live; trackBy: trackById"
                                    page="'participant'"
                                    [match]="match"
                                    [sportName]="sportName"
                                    [sportId]="sportId"
                                    (onSelect)="loadMatch($event)"
                                ></app-component-match>
                            </div>
                        </ng-container>
                        <!--End Live matches-->
                        <!--Participant latest matches-->
                        <ng-container *ngIf="participant.data.finished && participant.data.finished.length > 0">
                            <h6
                                class="table-sport__head bg-dark text-white"
                                data-toggle="collapse"
                                data-target="#collapse-1-latest"
                                role="button"
                                aria-expanded="true"
                                aria-controls="collapse-today"
                            >
                                <span class="table-sport__head__text">{{ 'web.latest_matches' | translate }}</span>
                            </h6>
                            <div class="collapse show" id="collapse-1-latest">
                                <ng-container
                                    *ngFor="
                                        let match of participant.data.finished | slice: 0 : 15;
                                        trackBy: trackById;
                                        index as index
                                    "
                                >
                                    <div
                                        *ngIf="
                                            index === 0 ||
                                            match.sub_tournament_id !==
                                                participant.data?.finished[index - 1]?.sub_tournament_id
                                        "
                                        data-toggle="collapse"
                                        role="button"
                                        class="table-sport__subhead d-flex align-items-center py-0 bg-light"
                                        href="#collapse-53136"
                                        aria-expanded="true"
                                        aria-controls="#collapse-53136"
                                    >
                                        <!-- <img
                                            width="16"
                                            height="16"
                                            loading="lazy"
                                            class="mr-2 rounded-circle ng-star-inserted"
                                            src="/flags/4x3/world.svg"
                                            alt="Mezinárodní  Přátelské zápasy mezistátní"
                                        /> -->
                                        <div class="table-sport__subhead__text my-2 my-sm-1 text-truncate mr-auto pr-1">
                                            <span class="d-inline ng-star-inserted">{{ match.category_name }} | </span>
                                            {{ match.sub_tournament_name }}
                                        </div>
                                        <a
                                            class="xsmall text-gray d-flex d-sm-none flex-column align-items-center text-uppercase p-2 border-left border-white app-category-detail-link"
                                            [routerLink]="[
                                                '/page/sport/event/',
                                                sportName + '-' + sportId,
                                                match.tournament_id,
                                            ]"
                                            [queryParams]="{ sid: match.sub_tournament_id }"
                                        >
                                            <svg class="icon icon--14 icon--gray mb-1">
                                                <use xlink:href="#icon-info"></use>
                                            </svg>
                                            {{ 'web.detail' | translate | transinit }} </a
                                        ><a
                                            class="small text-reset d-none d-sm-inline app-category-detail-link"
                                            [routerLink]="[
                                                '/page/sport/event/',
                                                sportName + '-' + sportId,
                                                match.tournament_id,
                                            ]"
                                            [queryParams]="{ sid: match.sub_tournament_id }"
                                        >
                                            <svg class="icon icon--12 mr-2 d-none dm-md-inline">
                                                <use xlink:href="#icon-table"></use>
                                            </svg>
                                            {{ 'web.detail' | translate | transinit }}</a
                                        >
                                    </div>

                                    <app-component-match
                                        [dateFormat]="'localDate'"
                                        page="'participant'"
                                        [match]="match"
                                        [sportName]="sportName"
                                        [sportId]="sportId"
                                        [participantId]="data.id"
                                        (onSelect)="loadMatch($event)"
                                    ></app-component-match>
                                </ng-container>
                                <div class="text-center mt-3 mb-4">
                                    <button
                                        class="btn btn-outline-secondary btn-sm px-5"
                                        (click)="tab('participantresults')"
                                    >
                                        {{ 'web.more_results' | translate }}
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                        <!--End Participantlatest matches-->
                        <!--Participant not started matches-->
                        <ng-container *ngIf="participant.data.not_started && participant.data.not_started.length > 0">
                            <h6
                                class="table-sport__head bg-dark text-white"
                                data-toggle="collapse"
                                data-target="#collapse-1-not_started"
                                role="button"
                                aria-expanded="true"
                                aria-controls="collapse-today"
                            >
                                <span class="table-sport__head__text">{{ 'web.not_started_matches' | translate }}</span>
                            </h6>
                            <div class="collapse show" id="collapse-1-not_started">
                                <ng-container
                                    *ngFor="
                                        let match of participant.data.not_started | slice: 0 : 15;
                                        trackBy: trackById;
                                        index as index
                                    "
                                >
                                    <div
                                        *ngIf="
                                            index === 0 ||
                                            match.sub_tournament_id !==
                                                participant.data?.not_started[index - 1].sub_tournament_id
                                        "
                                        data-toggle="collapse"
                                        role="button"
                                        class="table-sport__subhead d-flex align-items-center py-0 bg-light"
                                        href="#collapse-53136"
                                        aria-expanded="true"
                                        aria-controls="#collapse-53136"
                                    >
                                        <div class="table-sport__subhead__text my-2 my-sm-1 text-truncate mr-auto pr-1">
                                            <span class="d-inline ng-star-inserted">{{ match.category_name }} | </span>
                                            {{ match.sub_tournament_name }}
                                        </div>
                                        <a
                                            class="xsmall text-gray d-flex d-sm-none flex-column align-items-center text-uppercase p-2 border-left border-white app-category-detail-link"
                                            [routerLink]="[
                                                '/page/sport/event/',
                                                sportName + '-' + sportId,
                                                match.tournament_id,
                                            ]"
                                            [queryParams]="{ sid: match.sub_tournament_id }"
                                        >
                                            <svg class="icon icon--14 icon--gray mb-1">
                                                <use xlink:href="#icon-info"></use>
                                            </svg>
                                            {{ 'web.detail' | translate | transinit }} </a
                                        ><a
                                            class="small text-reset d-none d-sm-inline app-category-detail-link"
                                            [routerLink]="[
                                                '/page/sport/event/',
                                                sportName + '-' + sportId,
                                                match.tournament_id,
                                            ]"
                                            [queryParams]="{ sid: match.sub_tournament_id }"
                                        >
                                            <svg class="icon icon--12 mr-2 d-none dm-md-inline">
                                                <use xlink:href="#icon-table"></use>
                                            </svg>
                                            {{ 'web.detail' | translate | transinit }}</a
                                        >
                                    </div>
                                    <app-component-match
                                        [dateFormat]="'localDateTimeShort'"
                                        page="'participant'"
                                        [match]="match"
                                        [sportName]="sportName"
                                        [sportId]="sportId"
                                        (onSelect)="loadMatch($event)"
                                    ></app-component-match>
                                </ng-container>
                                <div class="text-center mt-3 mb-4">
                                    <button
                                        class="btn btn-outline-secondary btn-sm px-5"
                                        (click)="tab('participantfuture')"
                                    >
                                        {{ 'web.more_results' | translate }}
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                        <!--End Participant notstarted matches-->
                    </div>
                    <div
                        class="tab-pane"
                        data-cy="finished-matches"
                        [class.active]="activeTab == 2"
                        id="tab2-content"
                        role="tabpanel"
                        aria-labelledby="tab2"
                    >
                        <ng-container
                            *ngFor="
                                let match of participant.data.finished | slice: 0 : finishedLimit;
                                trackBy: trackById;
                                index as index
                            "
                        >
                            <div
                                *ngIf="
                                    index === 0 ||
                                    match.sub_tournament_id !== participant.data?.finished[index - 1]?.sub_tournament_id
                                "
                                data-toggle="collapse"
                                role="button"
                                class="table-sport__subhead d-flex align-items-center py-0 bg-light"
                                href="#collapse-53136"
                                aria-expanded="true"
                                aria-controls="#collapse-53136"
                            >
                                <div class="table-sport__subhead__text my-2 my-sm-1 text-truncate mr-auto pr-1">
                                    <span class="d-inline ng-star-inserted">{{ match.category_name }} | </span>
                                    {{ match.sub_tournament_name }}
                                </div>
                                <a
                                    class="xsmall text-gray d-flex d-sm-none flex-column align-items-center text-uppercase p-2 border-left border-white app-category-detail-link"
                                    [routerLink]="[
                                        '/page/sport/event/',
                                        sportName + '-' + sportId,
                                        match.tournament_id,
                                    ]"
                                    [queryParams]="{ sid: match.sub_tournament_id }"
                                >
                                    <svg class="icon icon--14 icon--gray mb-1">
                                        <use xlink:href="#icon-info"></use>
                                    </svg>
                                    {{ 'web.detail' | translate | transinit }} </a
                                ><a
                                    class="small text-reset d-none d-sm-inline app-category-detail-link"
                                    [routerLink]="[
                                        '/page/sport/event/',
                                        sportName + '-' + sportId,
                                        match.tournament_id,
                                    ]"
                                    [queryParams]="{ sid: match.sub_tournament_id }"
                                >
                                    <svg class="icon icon--12 mr-2 d-none dm-md-inline">
                                        <use xlink:href="#icon-table"></use>
                                    </svg>
                                    {{ 'web.detail' | translate | transinit }}</a
                                >
                            </div>
                            <app-component-match
                                [dateFormat]="'localDateTimeShort'"
                                page="'participant'"
                                [match]="match"
                                [sportName]="sportName"
                                [sportId]="sportId"
                                [participantId]="data.id"
                                (onSelect)="loadMatch($event)"
                            ></app-component-match>
                        </ng-container>
                        <div class="text-center mt-3 mb-4" *ngIf="!isDone('finished', participant.data)">
                            <button class="btn btn-outline-secondary btn-sm px-5" (click)="nextResult()">
                                {{ 'web.next_result' | translate }}
                            </button>
                        </div>

                        <div *ngIf="participant.data.finished.length == 0" class="text-center">
                            <strong>{{ 'web.no_data_found' | translate }}</strong>
                        </div>
                    </div>
                    <div
                        class="tab-pane"
                        data-cy="future-matches"
                        [class.active]="activeTab == 3"
                        id="tab3-content"
                        role="tabpanel"
                        aria-labelledby="tab3"
                    >
                        <ng-container
                            *ngFor="
                                let match of participant.data.not_started | slice: 0 : notStartedLimit;
                                trackBy: trackById;
                                index as index
                            "
                        >
                            <div
                                *ngIf="
                                    index === 0 ||
                                    match.sub_tournament_id !==
                                        participant.data?.not_started[index - 1]?.sub_tournament_id
                                "
                                data-toggle="collapse"
                                role="button"
                                class="table-sport__subhead d-flex align-items-center py-0 bg-light"
                                href="#collapse-53136"
                                aria-expanded="true"
                                aria-controls="#collapse-53136"
                            >
                                <div class="table-sport__subhead__text my-2 my-sm-1 text-truncate mr-auto pr-1">
                                    <span class="d-inline ng-star-inserted">{{ match.category_name }} | </span>
                                    {{ match.sub_tournament_name }}
                                </div>
                                <a
                                    class="xsmall text-gray d-flex d-sm-none flex-column align-items-center text-uppercase p-2 border-left border-white app-category-detail-link"
                                    [routerLink]="[
                                        '/page/sport/event/',
                                        sportName + '-' + sportId,
                                        match.tournament_id,
                                    ]"
                                    [queryParams]="{ sid: match.sub_tournament_id }"
                                >
                                    <svg class="icon icon--14 icon--gray mb-1">
                                        <use xlink:href="#icon-info"></use>
                                    </svg>
                                    {{ 'web.detail' | translate | transinit }} </a
                                ><a
                                    class="small text-reset d-none d-sm-inline app-category-detail-link"
                                    [routerLink]="[
                                        '/page/sport/event/',
                                        sportName + '-' + sportId,
                                        match.tournament_id,
                                    ]"
                                    [queryParams]="{ sid: match.sub_tournament_id }"
                                >
                                    <svg class="icon icon--12 mr-2 d-none dm-md-inline">
                                        <use xlink:href="#icon-table"></use>
                                    </svg>
                                    {{ 'web.detail' | translate | transinit }}</a
                                >
                            </div>

                            <app-component-match
                                [dateFormat]="'localDateTimeShort'"
                                page="'participant'"
                                [match]="match"
                                [sportName]="sportName"
                                [sportId]="sportId"
                                (onSelect)="loadMatch($event)"
                            ></app-component-match>
                        </ng-container>
                        <div class="text-center mt-3 mb-4" *ngIf="!isDone('not_started', participant.data)">
                            <button class="btn btn-outline-secondary btn-sm px-5" (click)="nextResult()">
                                {{ 'web.next_result' | translate }}
                            </button>
                        </div>

                        <div *ngIf="participant.data.not_started.length == 0" class="text-center">
                            <strong>{{ 'web.no_data_found' | translate }}</strong>
                        </div>
                    </div>
                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 4"
                        *ngIf="participant.players && participant.players.length > 0"
                        id="tab4-content"
                        role="tabpanel"
                        aria-labelledby="tab4"
                    >
                        <ng-container *ngIf="hasOptaStats">
                            <div class="mb-4">
                                @defer (on viewport) {
                                    <app-opta-season-player-stats
                                        [participantId]="optaTeam"
                                        [competitionId]="optaTournament"
                                        [seasonId]="optaSeason"
                                    ></app-opta-season-player-stats>
                                } @placeholder { <div></div> }
                            </div>
                            <div class="mb-4">
                                @defer (on viewport) {
                                    <app-opta-player-compare
                                        [participantId]="optaTeam"
                                        [competitionId]="optaTournament"
                                        [seasonId]="optaSeason"
                                    ></app-opta-player-compare>
                                } @placeholder { <div></div> }
                            </div>
                        </ng-container>
                        <app-players-v2
                            [id]="participant.id"
                            [data]="participant.players"
                            [sportName]="sportName"
                            [sportId]="sportId"
                            [seasonId]="getNearSeason"
                            [isNationalTeam]="participant.isNationalTeam"
                            [betradarMajorLeague]="isBetradarMajorLeague()"
                            (refresh)="onPlayerStatsSeasonChange($event)"
                        ></app-players-v2>
                    </div>

                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 5"
                        *ngIf="participant?.meta?.basic && participant.meta!.basic!.length > 0"
                        id="tab5-content"
                        role="tabpanel"
                        aria-labelledby="tab5"
                    >
                        <div class="table-responsive">
                            <div class="match-info__table small pb-2 text-center">
                                <div class="match-info__table__row player-record bg-dark text-white">
                                    <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                                    <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                                </div>

                                <div
                                    *ngFor="let row of participant.meta!.basic; trackBy: trackByIndex"
                                    class="match-info__table__row app-data-row-data player-record"
                                    data-cy="participant-stats-basic"
                                >
                                    <div class="match-info__table__cell text-left font-weight-bold border-top">
                                        {{ row.translation | translate }}:
                                    </div>
                                    <div class="match-info__table__cell text-left font-weight-bold border-top">
                                        <ng-container *ngIf="row.name == 'weight' || row.name == 'height'; else other">
                                            {{ row.value | unitConversion }}
                                        </ng-container>
                                        <ng-template #other>
                                            {{ row.value }}
                                        </ng-template>
                                    </div>
                                </div>
                                <div
                                    *ngIf="participant.awards.length > 0"
                                    class="match-info__table__row app-data-row-data player-record"
                                    data-cy="participant-stats-basic"
                                >
                                    <div class="match-info__table__cell text-left font-weight-bold border-top">
                                        {{ 'web.awards' | translate }}:
                                    </div>
                                    <div class="match-info__table__cell text-left font-weight-bold border-top">
                                        <span *ngFor="let award of data.awards; trackBy: trackByIndex" class="d-flex">
                                            <span>
                                                {{ award.season.year }}
                                            </span>
                                            <span class="mx-2">-</span>
                                            <span>{{ award.award.name }}</span>
                                            <span *ngIf="award.player" class="ml-2">
                                                (<a
                                                    [routerLink]="[
                                                        '/page/sport/player',
                                                        sportName + '-' + sportId,
                                                        award.player.id,
                                                    ]"
                                                    class="text-reset"
                                                    >{{ award.player.name }}</a
                                                >)
                                            </span>
                                            <br />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 6"
                        *ngIf="participant?.meta?.statistics && participant.meta!.statistics.length > 0"
                        id="tab6-content"
                        role="tabpanel"
                        aria-labelledby="tab6"
                    >
                        <div class="table-responsive">
                            <div class="match-info__table small pb-2 text-center">
                                <div class="match-info__table__row player-record bg-dark text-white">
                                    <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                                    <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                                </div>

                                <div
                                    *ngFor="let row of participant.meta!.statistics; trackBy: trackByIndex"
                                    class="match-info__table__row app-data-row-data player-record"
                                    data-cy="participant-stats-stats"
                                >
                                    <div class="match-info__table__cell text-left font-weight-bold border-top">
                                        {{ row.translation | translate }}:
                                    </div>
                                    <div class="match-info__table__cell text-left font-weight-bold border-top">
                                        {{ row.value }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 7"
                        *ngIf="participant?.news && participant!.news!.length > 0"
                        id="tab7-content"
                        role="tabpanel"
                        aria-labelledby="tab7"
                    >
                        <app-news [data]="participant.news"></app-news>
                    </div>
                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 7"
                        *ngIf="activeTab == 7"
                        id="players-transfers"
                        role="tabpanel"
                        aria-labelledby="tab7"
                    >
                        <app-player-transfers
                            [playerTransfers]="participant?.players_transfers"
                            [sportId]="sportId"
                            [sportName]="sportName"
                        ></app-player-transfers>
                    </div>
                    <div
                        class="tab-pane text-center"
                        [class.active]="activeTab == 11"
                        *ngIf="hasInfo && deviceService.isMobile()"
                        id="tab11-content"
                        role="tabpanel"
                        aria-labelledby="tab11"
                    >
                        <div class="row" *ngIf="shortSleeve">
                            <div
                                class="col-4 text-center"
                                *ngFor="let jersey of data!.jerseys; first as isFirst; trackBy: trackByIndex"
                            >
                                <span class="--small">{{ 'web.jersey_' + jersey.jerseyType | translate }} </span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    version="1.1"
                                    viewBox="0 0 1427.17 1373.9"
                                >
                                    <!-- Generator: Adobe Illustrator 29.4.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 152)  -->
                                    <defs>
                                        <style>
                                            .st0 {
                                                fill: none;
                                            }

                                            .st1 {
                                                fill: #940050;
                                            }

                                            .st2 {
                                                fill: #2000bf;
                                            }

                                            .st3 {
                                                fill: #d4ff15;
                                            }

                                            .st4 {
                                                font-family: Arial-BoldMT, Arial;
                                                font-size: 300px;
                                                font-weight: 700;
                                                stroke: #000;
                                                stroke-miterlimit: 10;
                                                stroke-width: 10px;
                                            }

                                            .st4,
                                            .st5 {
                                                fill: #fff;
                                            }

                                            .st6 {
                                                clip-path: url(#clippath-1);
                                            }

                                            .st7 {
                                                clip-path: url(#clippath-2);
                                            }

                                            .st8 {
                                                fill: #00a21d;
                                            }

                                            .st9 {
                                                opacity: 0.3;
                                            }

                                            .st10 {
                                                fill: #221f1f;
                                            }

                                            .st11 {
                                                fill: #0600bf;
                                            }

                                            .st12 {
                                                clip-path: url(#clippath);
                                            }
                                        </style>
                                        <clipPath id="clippath">
                                            <path
                                                class="st0"
                                                d="M1141.91,1368.97H280.66c-.67,0-1.31-.27-1.78-.75-.47-.48-.71-1.13-.69-1.8l19.85-549.29,15.46-324.66c0-118.63-56.34-186.49-86.61-222.95-6.74-8.12-12.07-14.54-15.57-19.96-.42-.65-.51-1.46-.25-2.18,18.62-51.21,52.65-97.49,86.68-117.89,125.85-75.45,202.7-96.68,203.46-96.89.49-.13,1.01-.11,1.49.07,45.18,16.43,210.97,27.66,212.64,27.77,1.28-.11,161.88-11.34,207.06-27.77.47-.17.98-.19,1.47-.07.79.21,79.99,21.44,205.85,96.89,34.03,20.4,68.06,66.68,86.68,117.89.26.73.17,1.54-.25,2.18-3.51,5.42-8.83,11.84-15.57,19.96-30.26,36.45-86.58,104.31-86.6,223.01l15.46,324.58,14.92,549.34c.02.67-.23,1.31-.7,1.79s-1.1.75-1.77.75Z"
                                            />
                                        </clipPath>
                                        <clipPath id="clippath-1">
                                            <path
                                                class="st0"
                                                d="M1141.91,1368.97H280.66c-.67,0-1.31-.27-1.78-.75-.47-.48-.71-1.13-.69-1.8l19.85-549.29,15.46-324.66c0-118.63-56.34-186.49-86.61-222.95-6.74-8.12-12.07-14.54-15.57-19.96-.42-.65-.51-1.46-.25-2.18,18.62-51.21,52.65-97.49,86.68-117.89,125.85-75.45,202.7-96.68,203.46-96.89.49-.13,1.01-.11,1.49.07,45.18,16.43,210.97,27.66,212.64,27.77,1.28-.11,161.88-11.34,207.06-27.77.47-.17.98-.19,1.47-.07.79.21,79.99,21.44,205.85,96.89,34.03,20.4,68.06,66.68,86.68,117.89.26.73.17,1.54-.25,2.18-3.51,5.42-8.83,11.84-15.57,19.96-30.26,36.45-86.58,104.31-86.6,223.01l15.46,324.58,14.92,549.34c.02.67-.23,1.31-.7,1.79s-1.1.75-1.77.75Z"
                                            />
                                        </clipPath>
                                        <clipPath id="clippath-2">
                                            <path
                                                class="st0"
                                                d="M1141.91,1368.97H280.66c-.67,0-1.31-.27-1.78-.75-.47-.48-.71-1.13-.69-1.8l19.85-549.29,15.46-324.66c0-118.63-56.34-186.49-86.61-222.95-6.74-8.12-12.07-14.54-15.57-19.96-.42-.65-.51-1.46-.25-2.18,18.62-51.21,52.65-97.49,86.68-117.89,125.85-75.45,202.7-96.68,203.46-96.89.49-.13,1.01-.11,1.49.07,45.18,16.43,210.97,27.66,212.64,27.77,1.28-.11,161.88-11.34,207.06-27.77.47-.17.98-.19,1.47-.07.79.21,79.99,21.44,205.85,96.89,34.03,20.4,68.06,66.68,86.68,117.89.26.73.17,1.54-.25,2.18-3.51,5.42-8.83,11.84-15.57,19.96-30.26,36.45-86.58,104.31-86.6,223.01l15.46,324.58,14.92,549.34c.02.67-.23,1.31-.7,1.79s-1.1.75-1.77.75Z"
                                            />
                                        </clipPath>
                                    </defs>
                                    <g id="RUKAVY">
                                        <g id="SLEEVE">
                                            <path
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'sleeve')"
                                                class="st11"
                                                d="M212.86,1335.07c-3.61,0-12.71-1.96-37.8-8.25-27.92-6.99-69.72-18.11-106.5-28.33-63.67-17.69-63.66-18.52-63.62-20.99.41-31.5,56.34-366.75,117.67-665.8,43.89-214.02,87.99-362.74,88.43-364.22.29-.96,1.12-1.65,2.11-1.75.75-.06,75.29-6.63,96.9,84.71,2.66,11.24,6.94,23.48,11.89,37.65,24.59,70.38,65.73,188.14,20.15,485.84.42,3.69,2.71,32.65-13.51,124.81-8.52,48.41-95.1,320.39-112.98,354.9-.42.81-.73,1.41-2.74,1.41Z"
                                            />
                                        </g>
                                        <g id="SLEEVE1" data-name="SLEEVE">
                                            <path
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'sleeve')"
                                                class="st2"
                                                d="M1214.28,1335.07c-2.01,0-2.32-.61-2.74-1.41-17.88-34.51-104.46-306.49-112.98-354.9-16.22-92.16-13.93-121.12-13.51-124.81-45.59-297.7-4.44-415.46,20.15-485.84,4.95-14.17,9.23-26.41,11.89-37.65,21.61-91.34,96.15-84.78,96.9-84.71.99.1,1.83.79,2.11,1.75.44,1.48,44.53,150.19,88.43,364.22,61.33,299.05,117.26,634.29,117.67,665.8.03,2.47.04,3.3-63.58,20.97-36.75,10.21-78.54,21.33-106.47,28.32-25.14,6.3-34.26,8.26-37.88,8.26Z"
                                            />
                                        </g>
                                    </g>
                                    <g id="BARVA_DRESU">
                                        <path
                                            [style.fill]="
                                                jerseyVal(jersey.jerseyType, 'squares')
                                                    ? jerseyColor(jersey.jerseyType, 'squaresColor')
                                                    : jerseyColor(jersey.jerseyType, 'base')
                                            "
                                            class="st3"
                                            d="M1141.91,1368.97H280.66c-.67,0-1.31-.27-1.78-.75-.47-.48-.71-1.13-.69-1.8l19.85-549.29,15.46-324.66c0-118.63-56.34-186.49-86.61-222.95-6.74-8.12-12.07-14.54-15.57-19.96-.42-.65-.51-1.46-.25-2.18,18.62-51.21,52.65-97.49,86.68-117.89,125.85-75.45,202.7-96.68,203.46-96.89.49-.13,1.01-.11,1.49.07,45.18,16.43,210.97,27.66,212.64,27.77,1.28-.11,161.88-11.34,207.06-27.77.47-.17.98-.19,1.47-.07.79.21,79.99,21.44,205.85,96.89,34.03,20.4,68.06,66.68,86.68,117.89.26.73.17,1.54-.25,2.18-3.51,5.42-8.83,11.84-15.57,19.96-30.26,36.45-86.58,104.31-86.6,223.01l15.46,324.58,14.92,549.34c.02.67-.23,1.31-.7,1.79s-1.1.75-1.77.75Z"
                                        />
                                    </g>
                                    <g id="SPLIT" *ngIf="jerseyVal(jersey.jerseyType, 'split')">
                                        <g class="st12">
                                            <rect
                                                class="st1"
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'splitColor')"
                                                x="710.21"
                                                y="-79.52"
                                                width="784.01"
                                                height="1532.26"
                                            />
                                        </g>
                                    </g>

                                    <g
                                        id="VERTICAL"
                                        *ngIf="
                                            jerseyVal(jersey.jerseyType, 'stripes') ||
                                            jerseyVal(jersey.jerseyType, 'squares')
                                        "
                                    >
                                        <g class="st6">
                                            <g>
                                                <rect
                                                    [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                    class="st8"
                                                    x="1053.16"
                                                    y="22.12"
                                                    width="88.34"
                                                    height="1504.73"
                                                    transform="translate(2194.65 1548.96) rotate(-180)"
                                                />
                                                <rect
                                                    [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                    class="st8"
                                                    x="860.14"
                                                    y="22.12"
                                                    width="88.34"
                                                    height="1504.73"
                                                    transform="translate(1808.62 1548.96) rotate(-180)"
                                                />
                                                <rect
                                                    [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                    class="st8"
                                                    x="667.12"
                                                    y="22.12"
                                                    width="88.34"
                                                    height="1504.73"
                                                    transform="translate(1422.58 1548.96) rotate(-180)"
                                                />
                                                <rect
                                                    [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                    class="st8"
                                                    x="474.1"
                                                    y="22.12"
                                                    width="88.34"
                                                    height="1504.73"
                                                    transform="translate(1036.54 1548.96) rotate(-180)"
                                                />
                                                <rect
                                                    [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                    class="st8"
                                                    x="281.09"
                                                    y="22.12"
                                                    width="88.34"
                                                    height="1504.73"
                                                    transform="translate(650.51 1548.96) rotate(-180)"
                                                />
                                            </g>
                                        </g>
                                    </g>

                                    <g
                                        id="HORIZONTAL"
                                        *ngIf="
                                            jerseyVal(jersey.jerseyType, 'horizontalStripes') ||
                                            jerseyVal(jersey.jerseyType, 'squares')
                                        "
                                    >
                                        <g class="st7">
                                            <g>
                                                <rect
                                                    [style.fill]="
                                                        jerseyColor(jersey.jerseyType, 'horizontalStripesColor')
                                                    "
                                                    class="st8"
                                                    x="670.87"
                                                    y="523.03"
                                                    width="88.34"
                                                    height="1149.71"
                                                    transform="translate(-382.85 1812.93) rotate(-90)"
                                                />
                                                <rect
                                                    [style.fill]="
                                                        jerseyColor(jersey.jerseyType, 'horizontalStripesColor')
                                                    "
                                                    class="st8"
                                                    x="670.87"
                                                    y="330.02"
                                                    width="88.34"
                                                    height="1149.71"
                                                    transform="translate(-189.83 1619.91) rotate(-90)"
                                                />
                                                <rect
                                                    [style.fill]="
                                                        jerseyColor(jersey.jerseyType, 'horizontalStripesColor')
                                                    "
                                                    class="st8"
                                                    x="670.87"
                                                    y="137"
                                                    width="88.34"
                                                    height="1149.71"
                                                    transform="translate(3.19 1426.89) rotate(-90)"
                                                />
                                                <rect
                                                    [style.fill]="
                                                        jerseyColor(jersey.jerseyType, 'horizontalStripesColor')
                                                    "
                                                    class="st8"
                                                    x="670.87"
                                                    y="-56.02"
                                                    width="88.34"
                                                    height="1149.71"
                                                    transform="translate(196.21 1233.87) rotate(-90)"
                                                />
                                                <rect
                                                    [style.fill]="
                                                        jerseyColor(jersey.jerseyType, 'horizontalStripesColor')
                                                    "
                                                    class="st8"
                                                    x="670.87"
                                                    y="-249.04"
                                                    width="88.34"
                                                    height="1149.71"
                                                    transform="translate(389.22 1040.86) rotate(-90)"
                                                />
                                                <rect
                                                    [style.fill]="
                                                        jerseyColor(jersey.jerseyType, 'horizontalStripesColor')
                                                    "
                                                    class="st8"
                                                    x="670.87"
                                                    y="-442.06"
                                                    width="88.34"
                                                    height="1149.71"
                                                    transform="translate(582.24 847.84) rotate(-90)"
                                                />
                                                <rect
                                                    [style.fill]="
                                                        jerseyColor(jersey.jerseyType, 'horizontalStripesColor')
                                                    "
                                                    class="st8"
                                                    x="670.87"
                                                    y="716.05"
                                                    width="88.34"
                                                    height="1149.71"
                                                    transform="translate(-575.87 2005.95) rotate(-90)"
                                                />
                                            </g>
                                        </g>
                                    </g>
                                    <g id="CISLO">
                                        <text
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'number')"
                                            class="st4"
                                            transform="translate(545.09 697.61)"
                                        >
                                            <tspan x="0" y="0">10</tspan>
                                        </text>
                                    </g>
                                    <g id="FRONT">
                                        <g>
                                            <path
                                                class="st5"
                                                d="M874.99,74.43c-25.51,75.81-80.59,213.78-161.59,281.85-81.06-68.13-135.67-206.17-160.88-281.97,51.19,19.48,152.32,22.32,152.32,22.32h18.07s100.84-2.83,152.09-22.2Z"
                                            />
                                            <path
                                                class="st10"
                                                d="M713.4,358.76c-.56,0-1.13-.19-1.59-.58-81.51-68.51-136.26-206.77-161.64-283.08-.3-.9-.05-1.9.63-2.56.69-.66,1.7-.86,2.59-.53,50.22,19.11,150.5,22.13,151.51,22.16h18c.93-.03,100.95-3.04,151.21-22.04.89-.34,1.9-.14,2.59.53.69.66.93,1.66.63,2.57-25.67,76.3-80.9,214.51-162.34,282.95-.46.39-1.02.58-1.59.58ZM556.48,78.37c25.7,76.18,78.89,207.93,156.92,274.68,77.98-66.7,131.62-198.41,157.61-274.57-52.31,17.74-147.06,20.59-148.04,20.62h-18.14c-1.05-.03-96.09-2.89-148.36-20.73Z"
                                            />
                                        </g>
                                        <g class="st9">
                                            <path
                                                class="st10"
                                                d="M874.99,79.38c-25.51,75.81-80.59,213.78-161.59,281.85-81.06-68.13-135.67-206.17-160.88-281.97,51.19,19.48,152.32,22.32,152.32,22.32h18.07s100.84-2.83,152.09-22.2Z"
                                            />
                                        </g>
                                        <g>
                                            <path
                                                d="M712.57,348.14v54.14c-13.71-8.57-26.54-18.5-37.76-29.96-107.86-110.34-170.45-327.89-172.93-337.35l48.23-27.48c.24.65,7.21,44.86,16.08,76.77,1.12,4.2,2.36,8.16,3.55,11.76,25.24,75.77,69.44,175.89,142.61,252.36.06-.06.18-.12.24-.24Z"
                                            />
                                            <path
                                                d="M712.57,404.75c-.45,0-.91-.13-1.31-.38-14.57-9.11-27.43-19.31-38.22-30.33-110.84-113.39-172.98-336.25-173.55-338.45-.28-1.08.19-2.22,1.17-2.77l48.23-27.48c.63-.36,1.39-.43,2.07-.17.68.25,1.22.79,1.47,1.47.11.31.11.31.73,3.9,1.98,11.48,8,46.4,15.4,73.05,1.23,4.58,2.59,8.84,3.51,11.65,23.87,71.68,67.68,173.13,140.94,250.27.07.01.15.03.22.04,1.11.26,1.8,1.44,1.8,2.59v54.14c0,.9-.49,1.72-1.27,2.16-.37.2-.79.31-1.2.31ZM504.77,36.16c6.15,21.53,67.15,227.37,171.8,334.43,9.58,9.78,20.84,18.91,33.53,27.18v-48.16c-74.29-77.88-118.61-180.43-142.72-252.82-.94-2.88-2.34-7.23-3.59-11.9-7.46-26.87-13.52-61.98-15.5-73.51,0,0,0-.01,0-.02l-43.51,24.8Z"
                                            />
                                        </g>
                                        <g>
                                            <path
                                                d="M721.79,42.12c-3.07.18-6.15.35-9.22.41-3.07-.06-6.15-.24-9.22-.41-34.93-2.48-125.3-4.55-153.25-34.63.24.65,7.21,44.86,16.08,76.77,53.6,16.9,138.53,19.56,138.53,19.56h15.72s84.93-2.66,138.53-19.56c8.87-31.91,15.84-76.12,16.08-76.77-27.95,30.08-118.32,32.15-153.25,34.63Z"
                                            />
                                            <path
                                                d="M712.57,106.29h-7.86c-.93-.03-85.96-2.87-139.28-19.68-.8-.25-1.41-.89-1.64-1.7-7.47-26.89-13.52-62-15.51-73.53-.32-1.86-.52-3.01-.58-3.3-.4-1.1.07-2.22,1.07-2.83,1-.61,2.33-.31,3.13.55,24.34,26.19,98.85,30.65,138.87,33.05,4.77.29,9.06.54,12.74.81,3.01.17,6.05.35,9.09.41,2.94-.06,5.97-.23,9.01-.41,3.68-.26,7.96-.52,12.73-.8,40.03-2.39,114.53-6.85,138.87-33.05.8-.87,2.09-1.04,3.1-.43,1,.61,1.43,1.85,1.03,2.95,0,.04-.19,1.2-.51,3.06-1.99,11.54-8.04,46.65-15.51,73.53-.22.81-.84,1.44-1.64,1.7-53.31,16.81-138.35,19.65-139.2,19.68h-7.94ZM568.2,82.3c52.74,16.25,135.75,19.02,136.59,19.05h15.64c.76-.03,83.78-2.8,136.51-19.05,6.58-24.07,12.02-54.34,14.42-68.13-29.7,23.21-98.58,27.33-136.71,29.61-4.75.28-9.02.54-12.69.8-.01,0-.02,0-.03,0-3.1.18-6.21.36-9.31.42-3.2-.06-6.31-.24-9.41-.42-3.7-.26-7.97-.52-12.72-.8-38.13-2.28-107.01-6.4-136.71-29.61,2.4,13.79,7.84,44.07,14.42,68.13ZM721.79,42.11h.05-.05Z"
                                            />
                                        </g>
                                        <g>
                                            <path
                                                d="M712.57,348.14v54.14c13.71-8.57,26.54-18.5,37.77-29.96,107.86-110.34,170.45-327.89,172.93-337.35l-48.23-27.48c-.24.65-7.21,44.86-16.08,76.77-1.12,4.2-2.36,8.16-3.55,11.76-25.24,75.77-69.44,175.89-142.61,252.36-.06-.06-.18-.12-.24-.24Z"
                                            />
                                            <path
                                                d="M712.57,404.75c-.41,0-.82-.1-1.2-.31-.79-.44-1.27-1.26-1.27-2.16v-54.14c0-1.1.73-2.07,1.78-2.37,73.41-77.16,117.29-178.76,141.19-250.54,1.48-4.52,2.56-8.11,3.5-11.62,7.41-26.67,13.43-61.6,15.41-73.07.62-3.59.62-3.6.73-3.9.25-.68.79-1.22,1.47-1.47.68-.26,1.44-.19,2.07.17l48.23,27.48c.97.55,1.45,1.69,1.17,2.77-.58,2.2-62.71,225.06-173.55,338.45-10.79,11.02-23.65,21.22-38.22,30.33-.4.25-.85.38-1.31.38ZM715.04,349.61v48.16c12.69-8.27,23.95-17.4,33.53-27.19,104.65-107.06,165.65-312.9,171.79-334.43l-43.51-24.8s0,.01,0,.02c-1.99,11.54-8.04,46.65-15.51,73.53-1.24,4.65-2.64,9-3.58,11.87-24.11,72.4-68.43,174.95-142.72,252.83Z"
                                            />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div *ngIf="noSleeve" class="row bg-light-emph">
                            <div
                                class="col-4 text-center"
                                *ngFor="let jersey of data!.jerseys; first as isFirst; trackBy: trackByIndex"
                            >
                                <span class="--small">{{ 'web.jersey_' + jersey.jerseyType | translate }} </span>
                                <svg
                                    version="1.0"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="100"
                                    height="100"
                                    viewBox="0 0 1200 1200"
                                >
                                    <path
                                        [style.fill]="jerseyColor(jersey.jerseyType, 'base')"
                                        d="M456.9 72.4c-.3.4-29.1 6-64 12.6-34.9 6.5-64.6 12.3-66 12.9-4 1.5-9.8 6.9-12.2 11.5l-2.2 4.1-.6 87.5c-.5 72.3-.9 89.6-2.2 99.5C299 379.8 272.5 441.7 228 491c-4.3 4.7-8.6 10.1-9.6 12-1.9 3.4-1.9 11.2-1.9 305.5 0 292.7.1 302.1 1.9 305.5 2.6 4.9 6.4 8.8 11.1 11.3l4 2.2h733l4-2.2c4.7-2.5 8.5-6.4 11.1-11.3 1.8-3.4 1.9-13 2.2-303.5.2-263.9 0-300.6-1.3-305.1-1.2-4-3.2-7-9.3-13.5-40-43.2-68.4-103.2-79.1-167.2-5.4-31.7-5.4-32.8-6-125.2-.5-79.2-.8-87.3-2.3-90-2.3-4.1-7.3-9.2-10.8-11-1.6-.8-30.1-6.4-63.3-12.4-33.2-6-62.7-11.7-65.6-12.7-9.7-3.1-13.7-1.7-34.7 12.4-10.8 7.3-30.9 17.7-43.4 22.5-50.3 19.5-95.1 18.1-147-4.7-11.2-4.9-30.1-15.8-38.5-22.1-3.9-2.9-8.6-6-10.5-7-3.4-1.7-14-3.2-15.1-2.1zm33.8 68.5c36.2 20 70.8 29.1 110.3 29.1 37.3-.1 69.7-8.5 105.6-27.5l12.3-6.5.7 5.7c1.7 13.5-1.9 38.8-7.9 56.8-5.1 15.1-9.9 24.7-19.4 38.8-37.1 55.1-101.5 68.9-153.3 32.6-19.1-13.3-37.7-37.8-47.3-62.4-7.5-18.8-12.7-48.7-11.2-64.2.4-4 .9-7.3 1.1-7.3.2 0 4.3 2.2 9.1 4.9zM564 515.8l12 11.9-.2 60.3-.3 60.3L516 684l-59.5 35.7-.3 12.1-.3 12.2H576v48H408l.2-48.2.3-48.1L468 660l59.5-35.7.3-36.1.2-36.2h-72v24h-48v-48.1l12.1-12 12-11.9h119.8l12.1 11.8zm216 0 12 11.9v96.4L780 636l-12 11.8 12 12 12 11.9v96.4l-12.1 12-12 11.9H648.3l-12.1-12.1-12.2-12.1V720h48v24h72v-72h-48v-48h48v-72h-72v24h-48v-48.1l12.1-12 12-11.9h119.8l12.1 11.8z"
                                    />
                                </svg>
                            </div>
                        </div>
                        <div class="row" *ngIf="longSleeve">
                            <div
                                class="col-4 text-center"
                                *ngFor="let jersey of data!.jerseys; first as isFirst; trackBy: trackByIndex"
                            >
                                <span class="--small">{{ 'web.jersey_' + jersey.jerseyType | translate }} </span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    version="1.1"
                                    viewBox="0 0 155.39 155.39"
                                >
                                    <!-- Generator: Adobe Illustrator 29.4.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 152)  -->
                                    <defs>
                                        <style>
                                            .st0 {
                                                fill: none;
                                            }

                                            .st1 {
                                                fill: #f3ff00;
                                            }

                                            .st2 {
                                                fill: #054796;
                                            }

                                            .st3 {
                                                fill: #fff;
                                                font-family: Arial-BoldMT, Arial;
                                                font-size: 28px;
                                                font-weight: 700;
                                                stroke: #000;
                                                stroke-miterlimit: 10;
                                            }

                                            .st4 {
                                                clip-path: url(#clippath-1);
                                            }

                                            .st5 {
                                                clip-path: url(#clippath-2);
                                            }

                                            .st6 {
                                                fill: #00a21d;
                                            }

                                            .st7 {
                                                fill: {
                                            {
                                            jerseyColor(jersey . jerseyType, 'splitColor')
                                            }
                                            };
                                            }

                                            .st8 {
                                                clip-path: url(#clippath);
                                            }

                                            .st9 {
                                                fill: url(#New_Pattern_Swatch_3);
                                            }
                                        </style>
                                        <clipPath id="clippath">
                                            <path
                                                class="st0"
                                                d="M122.63,25.55h0c-10.49-6.54-18.5-6.74-31.42-14.75,0,0-5.19,1.61-13.29,1.98-3.34,0-10.24-.9-13.74-1.98-12.93,8.01-20.84,8.18-31.42,14.75,5.59,9.59,10.01,33.63,10.01,33.63,5.43,25.07,1.33,57.48-.94,75.91-.06.47,3.54,2.27,4,2.27,0,0,11.65.75,16.23,0,2.4-.4,8.94-.02,15.64.25,6.69-.27,13.24-.65,15.63-.25,4.58.75,16.23,0,16.23,0,.47,0,4.06-1.8,4-2.27-2.26-18.42-6.37-50.82-.93-75.89,0-.01,0-.02,0-.02,0,0,4.42-24.04,10.01-33.63,0,0,0,0,0,0Z"
                                            />
                                        </clipPath>
                                        <clipPath id="clippath-1">
                                            <path
                                                class="st0"
                                                d="M122.63,25.55h0c-10.49-6.54-18.5-6.74-31.42-14.75,0,0-5.19,1.61-13.29,1.98-3.34,0-10.24-.9-13.74-1.98-12.93,8.01-20.84,8.18-31.42,14.75,5.59,9.59,10.01,33.63,10.01,33.63,5.43,25.07,1.33,57.48-.94,75.91-.06.47,3.54,2.27,4,2.27,0,0,11.65.75,16.23,0,2.4-.4,8.94-.02,15.64.25,6.69-.27,13.24-.65,15.63-.25,4.58.75,16.23,0,16.23,0,.47,0,4.06-1.8,4-2.27-2.26-18.42-6.37-50.82-.93-75.89,0-.01,0-.02,0-.02,0,0,4.42-24.04,10.01-33.63,0,0,0,0,0,0Z"
                                            />
                                        </clipPath>
                                        <clipPath id="clippath-2">
                                            <path
                                                class="st0"
                                                d="M122.63,25.55h0c-10.49-6.54-18.5-6.74-31.42-14.75,0,0-5.19,1.61-13.29,1.98-3.34,0-10.24-.9-13.74-1.98-12.93,8.01-20.84,8.18-31.42,14.75,5.59,9.59,10.01,33.63,10.01,33.63,5.43,25.07,1.33,57.48-.94,75.91-.06.47,3.54,2.27,4,2.27,0,0,11.65.75,16.23,0,2.4-.4,8.94-.02,15.64.25,6.69-.27,13.24-.65,15.63-.25,4.58.75,16.23,0,16.23,0,.47,0,4.06-1.8,4-2.27-2.26-18.42-6.37-50.82-.93-75.89,0-.01,0-.02,0-.02,0,0,4.42-24.04,10.01-33.63,0,0,0,0,0,0Z"
                                            />
                                        </clipPath>
                                        <pattern
                                            id="New_Pattern_Swatch_3"
                                            data-name="New Pattern Swatch 3"
                                            x="0"
                                            y="0"
                                            width="22.43"
                                            height="22.43"
                                            patternTransform="translate(-175.64 -63.96)"
                                            patternUnits="userSpaceOnUse"
                                            viewBox="0 0 22.43 22.43"
                                        >
                                            <g>
                                                <rect class="st0" width="22.43" height="22.43" />
                                                <rect class="st2" width="22.43" height="22.43" />
                                            </g>
                                        </pattern>
                                    </defs>
                                    <g id="BARVA_DRES">
                                        <path
                                            class="st1"
                                            [style.fill]="
                                                jerseyVal(jersey.jerseyType, 'squares')
                                                    ? jerseyColor(jersey.jerseyType, 'squaresColor')
                                                    : jerseyColor(jersey.jerseyType, 'base')
                                            "
                                            d="M122.63,25.55h0c-10.49-6.54-18.5-6.74-31.42-14.75,0,0-5.19,1.61-13.29,1.98-3.34,0-10.24-.9-13.74-1.98-12.93,8.01-20.84,8.18-31.42,14.75,5.59,9.59,10.01,33.63,10.01,33.63,5.43,25.07,1.33,57.48-.94,75.91-.06.47,3.54,2.27,4,2.27,0,0,11.65.75,16.23,0,2.4-.4,8.94-.02,15.64.25,6.69-.27,13.24-.65,15.63-.25,4.58.75,16.23,0,16.23,0,.47,0,4.06-1.8,4-2.27-2.26-18.42-6.37-50.82-.93-75.89,0-.01,0-.02,0-.02,0,0,4.42-24.04,10.01-33.63,0,0,0,0,0,0Z"
                                        />
                                    </g>
                                    <g id="SPLIT" *ngIf="jerseyVal(jersey.jerseyType, 'split')">
                                        <g class="st8">
                                            <rect
                                                class="st7"
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'splitColor')"
                                                x="77.83"
                                                y="-7.66"
                                                width="75.24"
                                                height="174.34"
                                            />
                                            <rect
                                                class="st7"
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'splitColor')"
                                                x="77.67"
                                                y="6.75"
                                                width="49.32"
                                                height="137.1"
                                            />
                                        </g>
                                    </g>
                                    <g
                                        id="VERTIKAL"
                                        *ngIf="
                                            jerseyVal(jersey.jerseyType, 'stripes') ||
                                            jerseyVal(jersey.jerseyType, 'squares')
                                        "
                                    >
                                        <g class="st4">
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st6"
                                                x="32.63"
                                                width="7.56"
                                                height="155.39"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st6"
                                                x="49.15"
                                                width="7.56"
                                                height="155.39"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st6"
                                                x="65.66"
                                                width="7.56"
                                                height="155.39"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st6"
                                                x="82.18"
                                                width="7.56"
                                                height="155.39"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st6"
                                                x="98.69"
                                                width="7.56"
                                                height="155.39"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st6"
                                                x="115.2"
                                                width="7.56"
                                                height="155.39"
                                            />
                                        </g>
                                    </g>
                                    <g
                                        id="HORIZONTAL"
                                        *ngIf="
                                            jerseyVal(jersey.jerseyType, 'horizontalStripes') ||
                                            jerseyVal(jersey.jerseyType, 'squares')
                                        "
                                    >
                                        <g class="st5">
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st6"
                                                x="73.92"
                                                y="31.26"
                                                width="7.56"
                                                height="155.39"
                                                transform="translate(-31.26 186.65) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st6"
                                                x="73.92"
                                                y="14.75"
                                                width="7.56"
                                                height="155.39"
                                                transform="translate(-14.75 170.15) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st6"
                                                x="73.92"
                                                y="-1.76"
                                                width="7.56"
                                                height="155.39"
                                                transform="translate(1.76 153.64) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st6"
                                                x="73.92"
                                                y="-18.27"
                                                width="7.56"
                                                height="155.39"
                                                transform="translate(18.27 137.13) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st6"
                                                x="73.92"
                                                y="-34.78"
                                                width="7.56"
                                                height="155.39"
                                                transform="translate(34.78 120.62) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st6"
                                                x="73.92"
                                                y="-51.29"
                                                width="7.56"
                                                height="155.39"
                                                transform="translate(51.29 104.11) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st6"
                                                x="73.92"
                                                y="47.77"
                                                width="7.56"
                                                height="155.39"
                                                transform="translate(-47.77 203.16) rotate(-90)"
                                            />
                                        </g>
                                    </g>
                                    <g id="RUKAVY">
                                        <path
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'sleeve')"
                                            class="st9"
                                            d="M136.29,63.12c-.6-3.9-1.39-9.46-1.97-15.24-.21-2.12-.39-4.27-.53-6.37-.17-2.65-1.05-5.13-2.41-7.4-1.73-2.88-4.23-5.39-7.09-7.43-.55-.39-1.11-.77-1.68-1.13-.1.18-.21.37-.31.56-1.38,2.51-2.68,5.87-3.85,9.48-.94,2.88-1.8,5.93-2.55,8.84-2.03,7.87-3.3,14.75-3.3,14.75,0,0,0,.01,0,.02,0,0,0-.02,0-.02,0,0,.22,1.07.59,2.65.87,3.74,2.53,10.32,3.9,12.29.11.16.22.29.32.39,1.28.11,2.92.12,4.73-.03,2.4-.19,5.09-.65,7.66-1.51.7-.24,1.39-.51,2.07-.81,2-.89,3.84-2.05,5.29-3.59,0,0-.38-2.12-.9-5.46Z"
                                        />
                                        <path
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'sleeve')"
                                            class="st9"
                                            d="M39.47,44.4c-.75-2.91-1.61-5.96-2.55-8.84-1.18-3.62-2.48-6.97-3.85-9.48-.1-.19-.2-.38-.31-.56-.57.36-1.13.74-1.68,1.13-2.85,2.04-5.36,4.55-7.09,7.43-1.36,2.26-2.24,4.75-2.41,7.4-.13,2.11-.32,4.25-.53,6.37-.57,5.78-1.36,11.34-1.97,15.24-.52,3.33-.9,5.46-.9,5.46,1.45,1.53,3.29,2.7,5.29,3.59.68.3,1.37.57,2.07.81,2.57.87,5.26,1.32,7.66,1.51,1.81.14,3.45.14,4.73.03.11-.1.21-.23.32-.39,1.37-1.97,3.03-8.55,3.9-12.29.37-1.58.59-2.65.59-2.65,0,0,0,.02,0,.02,0-.01,0-.02,0-.02,0,0-1.27-6.88-3.3-14.75Z"
                                        />
                                    </g>
                                    <g id="CISLO">
                                        <text
                                            class="st3"
                                            transform="translate(62.12 66.06)"
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'number')"
                                        >
                                            <tspan x="0" y="0">10</tspan>
                                        </text>
                                    </g>
                                    <g id="OTVOR">
                                        <path
                                            d="M91.22,10.81s-.04,0-.07,0c-.54.16-5.59,1.61-13.24,1.96-3.34,0-10.24-.9-13.74-1.98h0l-1.33.8c.46,9.72,9.59,15.96,13.3,18.1.97.56,2.15.59,3.14.07,3.62-1.89,12.21-7.48,13.2-18.22-.42-.25-.83-.49-1.27-.75Z"
                                        />
                                    </g>
                                </svg>
                            </div>
                        </div>

                        <app-participant-info
                            [participant]="data"
                            [sportId]="sportId"
                            [sportName]="sportName"
                        ></app-participant-info>
                        <div class="row">
                            <div class="col" *ngIf="hasScoredGoalsStats">
                                <iframe
                                    *ngIf="calculateScoresPeriodTotalMob"
                                    class="participant-score-iframe --mob"
                                    frameborder="0"
                                    scrolling="no"
                                    [src]="calculateScoresPeriodTotalMob | safe"
                                ></iframe>
                            </div>
                            <div class="col" *ngIf="hasScoredGoalsStats">
                                <iframe
                                    *ngIf="calculateConcatedPeriodTotalMob"
                                    class="participant-score-iframe --mob"
                                    frameborder="0"
                                    scrolling="no"
                                    [src]="calculateConcatedPeriodTotalMob | safe"
                                ></iframe>
                            </div>
                        </div>
                    </div>

                    <div
                        class="tab-pane"
                        *ngIf="activeTab == 8"
                        [class.active]="activeTab == 8"
                        id="tab8-content"
                        role="tabpanel"
                        aria-labelledby="tab8"
                    >
                        <app-tennis-bilance [bilance]="participant.balance"></app-tennis-bilance>
                    </div>
                    <div
                        class="tab-pane p-2"
                        *ngIf="activeTab == 10"
                        [class.active]="activeTab == 10"
                        id="tab10-content"
                        role="tabpanel"
                        aria-labelledby="tab8"
                    >
                        <!-- <app-qa
                            [participants]="[data.name]"
                            [random]="true"
                            [type]="aiParticipantType"
                            [sportName]="sportName"
                            [sportId]="sportId"
                            [tournaments]="uniqueTournaments"
                        ></app-qa> -->
                    </div>
                    <div
                        *ngIf="activeTab == 12"
                        class="tab-pane"
                        [class.active]="activeTab == 12"
                        id="tab12-content"
                        role="tabpanel"
                        aria-labelledby="tab12"
                    >
                        <ng-container *ngIf="hasOptaStats">
                            <app-auth-container
                                [authOff]="!client.use('signin')"
                                permission="premium_stats"
                                [extraPermission]="[
                                    'american_sports',
                                    'tracker',
                                    'stream',
                                    'betting_widgets',
                                    'stats',
                                    'all',
                                ]"
                            >
                                <div class="mb-4">
                                    @defer (on viewport) {
                                        <app-opta-expected-goals-season
                                            [participantId]="optaTeam"
                                            [competitionId]="optaTournament"
                                            [seasonId]="optaSeason"
                                        ></app-opta-expected-goals-season>
                                    } @placeholder { <div></div> }
                                </div>
                            </app-auth-container>
                        </ng-container>
                    </div>

                    <div
                        *ngIf="activeTab == 9"
                        class="tab-pane"
                        [class.active]="activeTab == 9"
                        id="tab9-content"
                        role="tabpanel"
                        aria-labelledby="tab9"
                    >
                        <ng-container *ngIf="hasOptaStats">
                            <div class="mb-4">
                                @defer (on viewport) {
                                    <app-opta-season-team-stats
                                        [participantId]="optaTeam"
                                        [competitionId]="optaTournament"
                                        [seasonId]="optaSeason"
                                    ></app-opta-season-team-stats>
                                } @placeholder { <div></div> }
                            </div>
                        </ng-container>
                        <ul
                            class="nav nav-pills bg-light px-2 app-league-table-container app-league-table-container--big mb-4"
                        >
                            <li class="nav-item ng-star-inserted" *ngIf="isSeasonStatsAvail">
                                <a
                                    class="nav-link app-cursor"
                                    [class.active]="activeStats === 1"
                                    (click)="onClickStats(1)"
                                    >{{ 'web.participant_stats_global' | translate }}</a
                                >
                            </li>
                            <li class="nav-item ng-star-inserted" *ngIf="data?.season_stats">
                                <a
                                    class="nav-link app-cursor"
                                    [class.active]="activeStats === 3"
                                    (click)="onClickStats(3)"
                                    >{{ 'web.participant_season-stats' | translate }}</a
                                >
                            </li>
                            <li class="nav-item ng-star-inserted" *ngIf="hasTableStandings">
                                <a
                                    class="nav-link app-cursor"
                                    [class.active]="activeStats === 2"
                                    (click)="onClickStats(2)"
                                >
                                    {{ 'web.participant_stats_season_standings' | translate }}
                                </a>
                            </li>
                        </ul>
                        <ng-container *ngIf="activeStats === 3; else particpantStandings">
                            <div>
                                <div class="d-flex flex-column p-1">
                                    <nav>
                                        <ol class="app-small-nav">
                                            <li
                                                class="crumb"
                                                *ngFor="
                                                    let tournament of data!.season_stats.tournaments | keys;
                                                    trackBy: trackByIndex
                                                "
                                            >
                                                <a
                                                    [routerLink]="['./']"
                                                    [queryParams]="{ statsKey: tournament.key }"
                                                    class="crumb__link"
                                                    [class.active]="
                                                        seasonStatsParam === tournament.key ||
                                                        (seasonStatsParam === null &&
                                                            tournament.value.tournament_selected)
                                                    "
                                                    (click)="
                                                        changeSeasonStatsTournament(tournament.value.tournament_id)
                                                    "
                                                    >{{ tournament.value.tournament_name }}</a
                                                >
                                            </li>
                                        </ol>
                                    </nav>
                                    <ng-container>
                                        <select
                                            class="custom-select border-light2 mb-3"
                                            (change)="onSeasonStatsSeasonChange($event)"
                                        >
                                            <option
                                                *ngFor="
                                                    let season of getSeasonStatsSeasons() | keys;
                                                    trackBy: trackByFnSeason
                                                "
                                                [value]="season.value.season_id"
                                            >
                                                {{ season.value.season_name }}
                                            </option>
                                        </select>
                                    </ng-container>
                                    <ng-container *ngIf="getSeasonStatsSelectedSeason().has_subtournaments">
                                        <select
                                            class="custom-select border-light2 mb-3"
                                            (change)="onSeasonStatsSubtournamentChange($event)"
                                        >
                                            <option
                                                *ngFor="
                                                    let subtournament of getSeasonStatsSubtournaments() | keys;
                                                    trackBy: trackByFnSubtournament
                                                "
                                                [value]="subtournament.value.subtournament_id"
                                            >
                                                {{ subtournament.value.subtournament_name }}
                                            </option>
                                        </select>
                                    </ng-container>
                                </div>
                                <ng-container *ngIf="!statsLoading; else loadingStats">
                                    <ng-container
                                        *ngIf="
                                            this.getSeasonStatsSelectedSeason().has_subtournaments;
                                            else seasonStatsWithoutTournament
                                        "
                                    >
                                        <ng-container
                                            *ngFor="
                                                let subtournament of this.getSeasonStatsSelectedSeason().subtournaments
                                                    | keys;
                                                first as isFirst;
                                                trackBy: trackByIndex
                                            "
                                        >
                                            <app-participant-season-stats
                                                *ngIf="
                                                    selectedStatsSubtournamentId ===
                                                        subtournament.value.subtournament_id ||
                                                    (selectedStatsSubtournamentId === null && isFirst)
                                                "
                                                [tournamentName]="
                                                    this.getSeasonStatsSelectedTournament().tournament_name
                                                "
                                                [tournamentCodename]="
                                                    this.getSeasonStatsSelectedTournament().tournament_codename
                                                "
                                                [betradarMajorLeague]="
                                                    this.getSeasonStatsSelectedTournament().betradar_major_league
                                                "
                                                [sportName]="sportName"
                                                [seasonName]="this.getSeasonStatsSelectedSeason().season_name"
                                                [subtournamentName]="subtournament.value.subtournament_name"
                                                [stats]="subtournament.value.statistics"
                                            ></app-participant-season-stats>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #seasonStatsWithoutTournament>
                                        <!-- *ngIf="seasonStatsParam === subtournament.key || (seasonStatsParam === null && isFirst) || true"-->
                                        <app-participant-season-stats
                                            [sportName]="sportName"
                                            [tournamentName]="this.getSeasonStatsSelectedTournament().tournament_name"
                                            [tournamentCodename]="this.getSeasonStatsSelectedTournament().tournament_codename"
                                            [betradarMajorLeague]="
                                                this.getSeasonStatsSelectedTournament().betradar_major_league
                                            "
                                            [seasonName]="this.getSeasonStatsSelectedSeason().season_name"
                                            [stats]="this.getSeasonStatsSelectedSeason().statistics ?? {}"
                                        ></app-participant-season-stats>
                                    </ng-template>
                                </ng-container>
                                <ng-template #loadingStats>
                                    <app-page-loader class="app-tracker-loader"></app-page-loader>
                                </ng-template>
                            </div>
                        </ng-container>
                        <ng-template #particpantStandings>
                            <ng-container *ngIf="activeStats === 1; else particpantStandings">
                                <app-participant-stats [pid]="id" [sportName]="sportName">
                                    <app-participant-stats-totals
                                        *ngIf="hasTotalStats"
                                        #playerStats
                                    ></app-participant-stats-totals>
                                    <app-participant-stats-goals
                                        *ngIf="hasGoalsStats"
                                        #playerStats
                                    ></app-participant-stats-goals>
                                    <app-participant-stats-uo
                                        *ngIf="hasUOStats"
                                        #playerStats
                                    ></app-participant-stats-uo>
                                    <app-participant-stats-match-result
                                        *ngIf="hasMatchScoreStats"
                                        #playerStats
                                    ></app-participant-stats-match-result>
                                    <app-participant-stats-scored-goals
                                        *ngIf="hasScoredGoalsStats"
                                        #playerStats
                                    ></app-participant-stats-scored-goals>
                                    <app-participant-stats-timeline
                                        *ngIf="hasTimelineStats"
                                        #playerStats
                                    ></app-participant-stats-timeline>
                                </app-participant-stats>
                            </ng-container>
                            <ng-template #particpantStandings>
                                <nav class="p-1">
                                    <ol class="app-small-nav">
                                        <li
                                            class="crumb ng-star-inserted"
                                            *ngFor="let item of this.participantTableSeason; trackBy: trackByIndex"
                                        >
                                            <a
                                                class="crumb__link active app-cursor"
                                                (click)="activeStatsSub = item[2]"
                                                [class.active]="item[2] === activeStatsSub"
                                                >{{ item[1] }} ({{ item[0] }})</a
                                            >
                                        </li>
                                    </ol>
                                </nav>
                                <div class="d-flex table-scrollable">
                                    <div class="table-scrollable__data flex-grow-1" tableScroll>
                                        <iframe
                                            *ngIf="calculateTableStandingsPath"
                                            class="participant-standings-iframe"
                                            frameborder="0"
                                            scrolling="no"
                                            [src]="
                                                calculateTableStandingsPath + '?lang=' + lang.getLangSnapshot() | safe
                                            "
                                        ></iframe>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-template>
                    </div>

                    <div
                        *ngIf="activeTab == 13"
                        class="tab-pane"
                        [class.active]="activeTab == 13"
                        id="tab13-content"
                        role="tabpanel"
                        aria-labelledby="tab13"
                    >
                        <app-grouped-participant-injuries
                            *ngIf="hasGroupedInjuries"
                            [sportName]="sportName"
                            [sportId]="sportId"
                            [participantId]="participant.id"
                            [seasonId]="getNearSeason"
                        ></app-grouped-participant-injuries>
                        <app-auth-container
                            [authOff]="!client.use('signin') || !isHockey(sportName)"
                            permission="premium_stats"
                            [extraPermission]="[
                                'american_sports',
                                'tracker',
                                'stream',
                                'betting_widgets',
                                'stats',
                                'all',
                            ]"
                        >
                            <app-injuries
                                *ngIf="!hasGroupedInjuries"
                                [sportId]="sportId"
                                [sportName]="sportName"
                                [participantId]="participant.id"
                                [showPracticeStatus]="false"
                            >
                            </app-injuries>
                        </app-auth-container>
                    </div>
                    <div
                        *ngIf="activeTab == 14"
                        class="tab-pane"
                        [class.active]="activeTab == 14"
                        id="tab14-content"
                        role="tabpanel"
                        aria-labelledby="tab14"
                    >
                        <app-participant-faceoffs
                            [sportId]="sportId"
                            [sportName]="sportName"
                            [tournamentId]="getFaceoffsTournamentId()"
                            [participantId]="id"
                        >
                        </app-participant-faceoffs>
                    </div>

                    <div *ngIf="client.use('seoCard') && data?.participant_info" class="card shadow border-0 mt-5">
                        <div class="app-info-card card-body p-0 p-md-5">
                            <div class="media">
                                <svg class="icon icon--32 mr-3">
                                    <use href="#icon-bulp-2" />
                                </svg>
                                <div class="media-body mt-2">
                                    <h6 class="font-weight-bold text-uppercase">{{ data?.name }}</h6>
                                    <div [innerHTML]="data?.participant_info | markdown"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <app-google-map-modal
                    [mapCoordinates]="participant.venue?.stadium_coords"
                    [(visible)]="map"
                ></app-google-map-modal>
            </ng-container>
            <ng-template #elseBlock>
                <app-placeholder-tournament [progress]="false"></app-placeholder-tournament>
            </ng-template>
        </div>
        <!-- Col Right -->
        <div class="col-lg-4 d-none d-lg-block" [ngClass]="matchClass">
            <div
                *ngIf="false && loaded && data?.goals_scored_conceded && data!.goals_scored_conceded!.length > 0"
                class="row text-center col-right__top px-lg-6 pt-4 goals-scored-conceded"
                data-cy="goals-scored-conceded"
            >
                <div class="row w-100">
                    <div class="col-6 pt-2">
                        <h5 class="text-uppercase font-weight-bold">{{ 'web.goals' | translate }}</h5>
                    </div>
                    <div class="col-6">
                        <select class="custom-select border-light2 mb-3" [(ngModel)]="gscTournamentIndex">
                            <option value="0">{{ 'web.select_tournament' | translate }}</option>
                            <option *ngFor="let gsc of data!.goals_scored_conceded; let i = index" [value]="i">
                                {{ gsc.tournament_name }}
                                {{ gsc.startYear == gsc.endYear ? gsc.startYear : gsc.startYear + '/' + gsc.endYear }}
                            </option>
                        </select>
                    </div>
                </div>
                <app-goals-scored-received
                    data-cy="app-goals-scored-received"
                    [data]="data.goals_scored_conceded[gscTournamentIndex]"
                ></app-goals-scored-received>
            </div>

            <div class="d-flex bg-white align-items-center" *ngIf="loaded && hasInfo">
                <div class="col">
                    <div class="text-center p-2 h-100">
                        <app-participant-info
                            [participant]="data"
                            [sportId]="sportId"
                            [sportName]="sportName"
                        ></app-participant-info>
                    </div>
                </div>
            </div>

            <div
                class="d-flex align-items-center bg-white app-form-canvas p-3"
                *ngIf="loaded && data.jerseys && data.jerseys.length > 0"
            >
                <div class="col">
                    <div class="row" *ngIf="longSleeve">
                        <div
                            class="col-3 text-center"
                            *ngFor="let jersey of data!.jerseys; first as isFirst; trackBy: trackByIndex"
                        >
                            <span class="--small">{{ 'web.jersey_' + jersey.jerseyType | translate }} </span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                version="1.1"
                                viewBox="0 0 1427.17 1373.9"
                            >
                                <!-- Generator: Adobe Illustrator 29.4.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 152)  -->
                                <defs>
                                    <style>
                                        .st0 {
                                            fill: none;
                                        }

                                        .st1 {
                                            fill: #940050;
                                        }

                                        .st2 {
                                            fill: #2000bf;
                                        }

                                        .st3 {
                                            fill: #d4ff15;
                                        }

                                        .st4 {
                                            font-family: Arial-BoldMT, Arial;
                                            font-size: 300px;
                                            font-weight: 700;
                                            stroke: #000;
                                            stroke-miterlimit: 10;
                                            stroke-width: 10px;
                                        }

                                        .st4,
                                        .st5 {
                                            fill: #fff;
                                        }

                                        .st6 {
                                            clip-path: url(#clippath-1);
                                        }

                                        .st7 {
                                            clip-path: url(#clippath-2);
                                        }

                                        .st8 {
                                            fill: #00a21d;
                                        }

                                        .st9 {
                                            opacity: 0.3;
                                        }

                                        .st10 {
                                            fill: #221f1f;
                                        }

                                        .st11 {
                                            fill: #0600bf;
                                        }

                                        .st12 {
                                            clip-path: url(#clippath);
                                        }
                                    </style>
                                    <clipPath id="clippath">
                                        <path
                                            class="st0"
                                            d="M1141.91,1368.97H280.66c-.67,0-1.31-.27-1.78-.75-.47-.48-.71-1.13-.69-1.8l19.85-549.29,15.46-324.66c0-118.63-56.34-186.49-86.61-222.95-6.74-8.12-12.07-14.54-15.57-19.96-.42-.65-.51-1.46-.25-2.18,18.62-51.21,52.65-97.49,86.68-117.89,125.85-75.45,202.7-96.68,203.46-96.89.49-.13,1.01-.11,1.49.07,45.18,16.43,210.97,27.66,212.64,27.77,1.28-.11,161.88-11.34,207.06-27.77.47-.17.98-.19,1.47-.07.79.21,79.99,21.44,205.85,96.89,34.03,20.4,68.06,66.68,86.68,117.89.26.73.17,1.54-.25,2.18-3.51,5.42-8.83,11.84-15.57,19.96-30.26,36.45-86.58,104.31-86.6,223.01l15.46,324.58,14.92,549.34c.02.67-.23,1.31-.7,1.79s-1.1.75-1.77.75Z"
                                        />
                                    </clipPath>
                                    <clipPath id="clippath-1">
                                        <path
                                            class="st0"
                                            d="M1141.91,1368.97H280.66c-.67,0-1.31-.27-1.78-.75-.47-.48-.71-1.13-.69-1.8l19.85-549.29,15.46-324.66c0-118.63-56.34-186.49-86.61-222.95-6.74-8.12-12.07-14.54-15.57-19.96-.42-.65-.51-1.46-.25-2.18,18.62-51.21,52.65-97.49,86.68-117.89,125.85-75.45,202.7-96.68,203.46-96.89.49-.13,1.01-.11,1.49.07,45.18,16.43,210.97,27.66,212.64,27.77,1.28-.11,161.88-11.34,207.06-27.77.47-.17.98-.19,1.47-.07.79.21,79.99,21.44,205.85,96.89,34.03,20.4,68.06,66.68,86.68,117.89.26.73.17,1.54-.25,2.18-3.51,5.42-8.83,11.84-15.57,19.96-30.26,36.45-86.58,104.31-86.6,223.01l15.46,324.58,14.92,549.34c.02.67-.23,1.31-.7,1.79s-1.1.75-1.77.75Z"
                                        />
                                    </clipPath>
                                    <clipPath id="clippath-2">
                                        <path
                                            class="st0"
                                            d="M1141.91,1368.97H280.66c-.67,0-1.31-.27-1.78-.75-.47-.48-.71-1.13-.69-1.8l19.85-549.29,15.46-324.66c0-118.63-56.34-186.49-86.61-222.95-6.74-8.12-12.07-14.54-15.57-19.96-.42-.65-.51-1.46-.25-2.18,18.62-51.21,52.65-97.49,86.68-117.89,125.85-75.45,202.7-96.68,203.46-96.89.49-.13,1.01-.11,1.49.07,45.18,16.43,210.97,27.66,212.64,27.77,1.28-.11,161.88-11.34,207.06-27.77.47-.17.98-.19,1.47-.07.79.21,79.99,21.44,205.85,96.89,34.03,20.4,68.06,66.68,86.68,117.89.26.73.17,1.54-.25,2.18-3.51,5.42-8.83,11.84-15.57,19.96-30.26,36.45-86.58,104.31-86.6,223.01l15.46,324.58,14.92,549.34c.02.67-.23,1.31-.7,1.79s-1.1.75-1.77.75Z"
                                        />
                                    </clipPath>
                                </defs>
                                <g id="RUKAVY">
                                    <g id="SLEEVE">
                                        <path
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'sleeve')"
                                            class="st11"
                                            d="M212.86,1335.07c-3.61,0-12.71-1.96-37.8-8.25-27.92-6.99-69.72-18.11-106.5-28.33-63.67-17.69-63.66-18.52-63.62-20.99.41-31.5,56.34-366.75,117.67-665.8,43.89-214.02,87.99-362.74,88.43-364.22.29-.96,1.12-1.65,2.11-1.75.75-.06,75.29-6.63,96.9,84.71,2.66,11.24,6.94,23.48,11.89,37.65,24.59,70.38,65.73,188.14,20.15,485.84.42,3.69,2.71,32.65-13.51,124.81-8.52,48.41-95.1,320.39-112.98,354.9-.42.81-.73,1.41-2.74,1.41Z"
                                        />
                                    </g>
                                    <g id="SLEEVE1" data-name="SLEEVE">
                                        <path
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'sleeve')"
                                            class="st2"
                                            d="M1214.28,1335.07c-2.01,0-2.32-.61-2.74-1.41-17.88-34.51-104.46-306.49-112.98-354.9-16.22-92.16-13.93-121.12-13.51-124.81-45.59-297.7-4.44-415.46,20.15-485.84,4.95-14.17,9.23-26.41,11.89-37.65,21.61-91.34,96.15-84.78,96.9-84.71.99.1,1.83.79,2.11,1.75.44,1.48,44.53,150.19,88.43,364.22,61.33,299.05,117.26,634.29,117.67,665.8.03,2.47.04,3.3-63.58,20.97-36.75,10.21-78.54,21.33-106.47,28.32-25.14,6.3-34.26,8.26-37.88,8.26Z"
                                        />
                                    </g>
                                </g>
                                <g id="BARVA_DRESU">
                                    <path
                                        [style.fill]="
                                            jerseyVal(jersey.jerseyType, 'squares')
                                                ? jerseyColor(jersey.jerseyType, 'squaresColor')
                                                : jerseyColor(jersey.jerseyType, 'base')
                                        "
                                        class="st3"
                                        d="M1141.91,1368.97H280.66c-.67,0-1.31-.27-1.78-.75-.47-.48-.71-1.13-.69-1.8l19.85-549.29,15.46-324.66c0-118.63-56.34-186.49-86.61-222.95-6.74-8.12-12.07-14.54-15.57-19.96-.42-.65-.51-1.46-.25-2.18,18.62-51.21,52.65-97.49,86.68-117.89,125.85-75.45,202.7-96.68,203.46-96.89.49-.13,1.01-.11,1.49.07,45.18,16.43,210.97,27.66,212.64,27.77,1.28-.11,161.88-11.34,207.06-27.77.47-.17.98-.19,1.47-.07.79.21,79.99,21.44,205.85,96.89,34.03,20.4,68.06,66.68,86.68,117.89.26.73.17,1.54-.25,2.18-3.51,5.42-8.83,11.84-15.57,19.96-30.26,36.45-86.58,104.31-86.6,223.01l15.46,324.58,14.92,549.34c.02.67-.23,1.31-.7,1.79s-1.1.75-1.77.75Z"
                                    />
                                </g>
                                <g id="SPLIT" *ngIf="jerseyVal(jersey.jerseyType, 'split')">
                                    <g class="st12">
                                        <rect
                                            class="st1"
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'splitColor')"
                                            x="710.21"
                                            y="-79.52"
                                            width="784.01"
                                            height="1532.26"
                                        />
                                    </g>
                                </g>

                                <g
                                    id="VERTICAL"
                                    *ngIf="
                                        jerseyVal(jersey.jerseyType, 'stripes') ||
                                        jerseyVal(jersey.jerseyType, 'squares')
                                    "
                                >
                                    <g class="st6">
                                        <g>
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st8"
                                                x="1053.16"
                                                y="22.12"
                                                width="88.34"
                                                height="1504.73"
                                                transform="translate(2194.65 1548.96) rotate(-180)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st8"
                                                x="860.14"
                                                y="22.12"
                                                width="88.34"
                                                height="1504.73"
                                                transform="translate(1808.62 1548.96) rotate(-180)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st8"
                                                x="667.12"
                                                y="22.12"
                                                width="88.34"
                                                height="1504.73"
                                                transform="translate(1422.58 1548.96) rotate(-180)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st8"
                                                x="474.1"
                                                y="22.12"
                                                width="88.34"
                                                height="1504.73"
                                                transform="translate(1036.54 1548.96) rotate(-180)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                                class="st8"
                                                x="281.09"
                                                y="22.12"
                                                width="88.34"
                                                height="1504.73"
                                                transform="translate(650.51 1548.96) rotate(-180)"
                                            />
                                        </g>
                                    </g>
                                </g>

                                <g
                                    id="HORIZONTAL"
                                    *ngIf="
                                        jerseyVal(jersey.jerseyType, 'horizontalStripes') ||
                                        jerseyVal(jersey.jerseyType, 'squares')
                                    "
                                >
                                    <g class="st7">
                                        <g>
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st8"
                                                x="670.87"
                                                y="523.03"
                                                width="88.34"
                                                height="1149.71"
                                                transform="translate(-382.85 1812.93) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st8"
                                                x="670.87"
                                                y="330.02"
                                                width="88.34"
                                                height="1149.71"
                                                transform="translate(-189.83 1619.91) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st8"
                                                x="670.87"
                                                y="137"
                                                width="88.34"
                                                height="1149.71"
                                                transform="translate(3.19 1426.89) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st8"
                                                x="670.87"
                                                y="-56.02"
                                                width="88.34"
                                                height="1149.71"
                                                transform="translate(196.21 1233.87) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st8"
                                                x="670.87"
                                                y="-249.04"
                                                width="88.34"
                                                height="1149.71"
                                                transform="translate(389.22 1040.86) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st8"
                                                x="670.87"
                                                y="-442.06"
                                                width="88.34"
                                                height="1149.71"
                                                transform="translate(582.24 847.84) rotate(-90)"
                                            />
                                            <rect
                                                [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                                class="st8"
                                                x="670.87"
                                                y="716.05"
                                                width="88.34"
                                                height="1149.71"
                                                transform="translate(-575.87 2005.95) rotate(-90)"
                                            />
                                        </g>
                                    </g>
                                </g>
                                <g id="CISLO">
                                    <text
                                        [style.fill]="jerseyColor(jersey.jerseyType, 'number')"
                                        class="st4"
                                        transform="translate(545.09 697.61)"
                                    >
                                        <tspan x="0" y="0">10</tspan>
                                    </text>
                                </g>
                                <g id="FRONT">
                                    <g>
                                        <path
                                            class="st5"
                                            d="M874.99,74.43c-25.51,75.81-80.59,213.78-161.59,281.85-81.06-68.13-135.67-206.17-160.88-281.97,51.19,19.48,152.32,22.32,152.32,22.32h18.07s100.84-2.83,152.09-22.2Z"
                                        />
                                        <path
                                            class="st10"
                                            d="M713.4,358.76c-.56,0-1.13-.19-1.59-.58-81.51-68.51-136.26-206.77-161.64-283.08-.3-.9-.05-1.9.63-2.56.69-.66,1.7-.86,2.59-.53,50.22,19.11,150.5,22.13,151.51,22.16h18c.93-.03,100.95-3.04,151.21-22.04.89-.34,1.9-.14,2.59.53.69.66.93,1.66.63,2.57-25.67,76.3-80.9,214.51-162.34,282.95-.46.39-1.02.58-1.59.58ZM556.48,78.37c25.7,76.18,78.89,207.93,156.92,274.68,77.98-66.7,131.62-198.41,157.61-274.57-52.31,17.74-147.06,20.59-148.04,20.62h-18.14c-1.05-.03-96.09-2.89-148.36-20.73Z"
                                        />
                                    </g>
                                    <g class="st9">
                                        <path
                                            class="st10"
                                            d="M874.99,79.38c-25.51,75.81-80.59,213.78-161.59,281.85-81.06-68.13-135.67-206.17-160.88-281.97,51.19,19.48,152.32,22.32,152.32,22.32h18.07s100.84-2.83,152.09-22.2Z"
                                        />
                                    </g>
                                    <g>
                                        <path
                                            d="M712.57,348.14v54.14c-13.71-8.57-26.54-18.5-37.76-29.96-107.86-110.34-170.45-327.89-172.93-337.35l48.23-27.48c.24.65,7.21,44.86,16.08,76.77,1.12,4.2,2.36,8.16,3.55,11.76,25.24,75.77,69.44,175.89,142.61,252.36.06-.06.18-.12.24-.24Z"
                                        />
                                        <path
                                            d="M712.57,404.75c-.45,0-.91-.13-1.31-.38-14.57-9.11-27.43-19.31-38.22-30.33-110.84-113.39-172.98-336.25-173.55-338.45-.28-1.08.19-2.22,1.17-2.77l48.23-27.48c.63-.36,1.39-.43,2.07-.17.68.25,1.22.79,1.47,1.47.11.31.11.31.73,3.9,1.98,11.48,8,46.4,15.4,73.05,1.23,4.58,2.59,8.84,3.51,11.65,23.87,71.68,67.68,173.13,140.94,250.27.07.01.15.03.22.04,1.11.26,1.8,1.44,1.8,2.59v54.14c0,.9-.49,1.72-1.27,2.16-.37.2-.79.31-1.2.31ZM504.77,36.16c6.15,21.53,67.15,227.37,171.8,334.43,9.58,9.78,20.84,18.91,33.53,27.18v-48.16c-74.29-77.88-118.61-180.43-142.72-252.82-.94-2.88-2.34-7.23-3.59-11.9-7.46-26.87-13.52-61.98-15.5-73.51,0,0,0-.01,0-.02l-43.51,24.8Z"
                                        />
                                    </g>
                                    <g>
                                        <path
                                            d="M721.79,42.12c-3.07.18-6.15.35-9.22.41-3.07-.06-6.15-.24-9.22-.41-34.93-2.48-125.3-4.55-153.25-34.63.24.65,7.21,44.86,16.08,76.77,53.6,16.9,138.53,19.56,138.53,19.56h15.72s84.93-2.66,138.53-19.56c8.87-31.91,15.84-76.12,16.08-76.77-27.95,30.08-118.32,32.15-153.25,34.63Z"
                                        />
                                        <path
                                            d="M712.57,106.29h-7.86c-.93-.03-85.96-2.87-139.28-19.68-.8-.25-1.41-.89-1.64-1.7-7.47-26.89-13.52-62-15.51-73.53-.32-1.86-.52-3.01-.58-3.3-.4-1.1.07-2.22,1.07-2.83,1-.61,2.33-.31,3.13.55,24.34,26.19,98.85,30.65,138.87,33.05,4.77.29,9.06.54,12.74.81,3.01.17,6.05.35,9.09.41,2.94-.06,5.97-.23,9.01-.41,3.68-.26,7.96-.52,12.73-.8,40.03-2.39,114.53-6.85,138.87-33.05.8-.87,2.09-1.04,3.1-.43,1,.61,1.43,1.85,1.03,2.95,0,.04-.19,1.2-.51,3.06-1.99,11.54-8.04,46.65-15.51,73.53-.22.81-.84,1.44-1.64,1.7-53.31,16.81-138.35,19.65-139.2,19.68h-7.94ZM568.2,82.3c52.74,16.25,135.75,19.02,136.59,19.05h15.64c.76-.03,83.78-2.8,136.51-19.05,6.58-24.07,12.02-54.34,14.42-68.13-29.7,23.21-98.58,27.33-136.71,29.61-4.75.28-9.02.54-12.69.8-.01,0-.02,0-.03,0-3.1.18-6.21.36-9.31.42-3.2-.06-6.31-.24-9.41-.42-3.7-.26-7.97-.52-12.72-.8-38.13-2.28-107.01-6.4-136.71-29.61,2.4,13.79,7.84,44.07,14.42,68.13ZM721.79,42.11h.05-.05Z"
                                        />
                                    </g>
                                    <g>
                                        <path
                                            d="M712.57,348.14v54.14c13.71-8.57,26.54-18.5,37.77-29.96,107.86-110.34,170.45-327.89,172.93-337.35l-48.23-27.48c-.24.65-7.21,44.86-16.08,76.77-1.12,4.2-2.36,8.16-3.55,11.76-25.24,75.77-69.44,175.89-142.61,252.36-.06-.06-.18-.12-.24-.24Z"
                                        />
                                        <path
                                            d="M712.57,404.75c-.41,0-.82-.1-1.2-.31-.79-.44-1.27-1.26-1.27-2.16v-54.14c0-1.1.73-2.07,1.78-2.37,73.41-77.16,117.29-178.76,141.19-250.54,1.48-4.52,2.56-8.11,3.5-11.62,7.41-26.67,13.43-61.6,15.41-73.07.62-3.59.62-3.6.73-3.9.25-.68.79-1.22,1.47-1.47.68-.26,1.44-.19,2.07.17l48.23,27.48c.97.55,1.45,1.69,1.17,2.77-.58,2.2-62.71,225.06-173.55,338.45-10.79,11.02-23.65,21.22-38.22,30.33-.4.25-.85.38-1.31.38ZM715.04,349.61v48.16c12.69-8.27,23.95-17.4,33.53-27.19,104.65-107.06,165.65-312.9,171.79-334.43l-43.51-24.8s0,.01,0,.02c-1.99,11.54-8.04,46.65-15.51,73.53-1.24,4.65-2.64,9-3.58,11.87-24.11,72.4-68.43,174.95-142.72,252.83Z"
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <div class="row" *ngIf="noSleeve">
                        <div
                            class="col-3 text-center"
                            *ngFor="let jersey of data!.jerseys; first as isFirst; trackBy: trackByIndex"
                        >
                            <span class="--small">{{ 'web.jersey_' + jersey.jerseyType | translate }} </span>
                            <svg
                                version="1.0"
                                xmlns="http://www.w3.org/2000/svg"
                                width="100"
                                height="100"
                                viewBox="0 0 1200 1200"
                            >
                                <path
                                    [style.fill]="jerseyColor(jersey.jerseyType, 'base')"
                                    d="M456.9 72.4c-.3.4-29.1 6-64 12.6-34.9 6.5-64.6 12.3-66 12.9-4 1.5-9.8 6.9-12.2 11.5l-2.2 4.1-.6 87.5c-.5 72.3-.9 89.6-2.2 99.5C299 379.8 272.5 441.7 228 491c-4.3 4.7-8.6 10.1-9.6 12-1.9 3.4-1.9 11.2-1.9 305.5 0 292.7.1 302.1 1.9 305.5 2.6 4.9 6.4 8.8 11.1 11.3l4 2.2h733l4-2.2c4.7-2.5 8.5-6.4 11.1-11.3 1.8-3.4 1.9-13 2.2-303.5.2-263.9 0-300.6-1.3-305.1-1.2-4-3.2-7-9.3-13.5-40-43.2-68.4-103.2-79.1-167.2-5.4-31.7-5.4-32.8-6-125.2-.5-79.2-.8-87.3-2.3-90-2.3-4.1-7.3-9.2-10.8-11-1.6-.8-30.1-6.4-63.3-12.4-33.2-6-62.7-11.7-65.6-12.7-9.7-3.1-13.7-1.7-34.7 12.4-10.8 7.3-30.9 17.7-43.4 22.5-50.3 19.5-95.1 18.1-147-4.7-11.2-4.9-30.1-15.8-38.5-22.1-3.9-2.9-8.6-6-10.5-7-3.4-1.7-14-3.2-15.1-2.1zm33.8 68.5c36.2 20 70.8 29.1 110.3 29.1 37.3-.1 69.7-8.5 105.6-27.5l12.3-6.5.7 5.7c1.7 13.5-1.9 38.8-7.9 56.8-5.1 15.1-9.9 24.7-19.4 38.8-37.1 55.1-101.5 68.9-153.3 32.6-19.1-13.3-37.7-37.8-47.3-62.4-7.5-18.8-12.7-48.7-11.2-64.2.4-4 .9-7.3 1.1-7.3.2 0 4.3 2.2 9.1 4.9zM564 515.8l12 11.9-.2 60.3-.3 60.3L516 684l-59.5 35.7-.3 12.1-.3 12.2H576v48H408l.2-48.2.3-48.1L468 660l59.5-35.7.3-36.1.2-36.2h-72v24h-48v-48.1l12.1-12 12-11.9h119.8l12.1 11.8zm216 0 12 11.9v96.4L780 636l-12 11.8 12 12 12 11.9v96.4l-12.1 12-12 11.9H648.3l-12.1-12.1-12.2-12.1V720h48v24h72v-72h-48v-48h48v-72h-72v24h-48v-48.1l12.1-12 12-11.9h119.8l12.1 11.8z"
                                />
                            </svg>
                        </div>
                    </div>
                    <div class="row" *ngIf="shortSleeve">
                        <div
                            class="col-3 text-center"
                            *ngFor="let jersey of data!.jerseys; first as isFirst; trackBy: trackByIndex"
                        >
                            <span class="--small">{{ 'web.jersey_' + jersey.jerseyType | translate }} </span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                version="1.1"
                                viewBox="0 0 155.39 155.39"
                            >
                                <!-- Generator: Adobe Illustrator 29.4.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 152)  -->
                                <defs>
                                    <style>
                                        .st0 {
                                            fill: none;
                                        }

                                        .st1 {
                                            fill: #f3ff00;
                                        }

                                        .st2 {
                                            fill: #054796;
                                        }

                                        .st3 {
                                            fill: #fff;
                                            font-family: Arial-BoldMT, Arial;
                                            font-size: 28px;
                                            font-weight: 700;
                                            stroke: #000;
                                            stroke-miterlimit: 10;
                                        }

                                        .st4 {
                                            clip-path: url(#clippath-1);
                                        }

                                        .st5 {
                                            clip-path: url(#clippath-2);
                                        }

                                        .st6 {
                                            fill: #00a21d;
                                        }

                                        .st7 {
                                            fill: {
                                        {
                                        jerseyColor(jersey . jerseyType, 'splitColor')
                                        }
                                        };
                                        }

                                        .st8 {
                                            clip-path: url(#clippath);
                                        }

                                        .st9 {
                                            fill: url(#New_Pattern_Swatch_3);
                                        }
                                    </style>
                                    <clipPath id="clippath">
                                        <path
                                            class="st0"
                                            d="M122.63,25.55h0c-10.49-6.54-18.5-6.74-31.42-14.75,0,0-5.19,1.61-13.29,1.98-3.34,0-10.24-.9-13.74-1.98-12.93,8.01-20.84,8.18-31.42,14.75,5.59,9.59,10.01,33.63,10.01,33.63,5.43,25.07,1.33,57.48-.94,75.91-.06.47,3.54,2.27,4,2.27,0,0,11.65.75,16.23,0,2.4-.4,8.94-.02,15.64.25,6.69-.27,13.24-.65,15.63-.25,4.58.75,16.23,0,16.23,0,.47,0,4.06-1.8,4-2.27-2.26-18.42-6.37-50.82-.93-75.89,0-.01,0-.02,0-.02,0,0,4.42-24.04,10.01-33.63,0,0,0,0,0,0Z"
                                        />
                                    </clipPath>
                                    <clipPath id="clippath-1">
                                        <path
                                            class="st0"
                                            d="M122.63,25.55h0c-10.49-6.54-18.5-6.74-31.42-14.75,0,0-5.19,1.61-13.29,1.98-3.34,0-10.24-.9-13.74-1.98-12.93,8.01-20.84,8.18-31.42,14.75,5.59,9.59,10.01,33.63,10.01,33.63,5.43,25.07,1.33,57.48-.94,75.91-.06.47,3.54,2.27,4,2.27,0,0,11.65.75,16.23,0,2.4-.4,8.94-.02,15.64.25,6.69-.27,13.24-.65,15.63-.25,4.58.75,16.23,0,16.23,0,.47,0,4.06-1.8,4-2.27-2.26-18.42-6.37-50.82-.93-75.89,0-.01,0-.02,0-.02,0,0,4.42-24.04,10.01-33.63,0,0,0,0,0,0Z"
                                        />
                                    </clipPath>
                                    <clipPath id="clippath-2">
                                        <path
                                            class="st0"
                                            d="M122.63,25.55h0c-10.49-6.54-18.5-6.74-31.42-14.75,0,0-5.19,1.61-13.29,1.98-3.34,0-10.24-.9-13.74-1.98-12.93,8.01-20.84,8.18-31.42,14.75,5.59,9.59,10.01,33.63,10.01,33.63,5.43,25.07,1.33,57.48-.94,75.91-.06.47,3.54,2.27,4,2.27,0,0,11.65.75,16.23,0,2.4-.4,8.94-.02,15.64.25,6.69-.27,13.24-.65,15.63-.25,4.58.75,16.23,0,16.23,0,.47,0,4.06-1.8,4-2.27-2.26-18.42-6.37-50.82-.93-75.89,0-.01,0-.02,0-.02,0,0,4.42-24.04,10.01-33.63,0,0,0,0,0,0Z"
                                        />
                                    </clipPath>
                                    <pattern
                                        id="New_Pattern_Swatch_3"
                                        data-name="New Pattern Swatch 3"
                                        x="0"
                                        y="0"
                                        width="22.43"
                                        height="22.43"
                                        patternTransform="translate(-175.64 -63.96)"
                                        patternUnits="userSpaceOnUse"
                                        viewBox="0 0 22.43 22.43"
                                    >
                                        <g>
                                            <rect class="st0" width="22.43" height="22.43" />
                                            <rect class="st2" width="22.43" height="22.43" />
                                        </g>
                                    </pattern>
                                </defs>
                                <g id="BARVA_DRES">
                                    <path
                                        class="st1"
                                        [style.fill]="
                                            jerseyVal(jersey.jerseyType, 'squares')
                                                ? jerseyColor(jersey.jerseyType, 'squaresColor')
                                                : jerseyColor(jersey.jerseyType, 'base')
                                        "
                                        d="M122.63,25.55h0c-10.49-6.54-18.5-6.74-31.42-14.75,0,0-5.19,1.61-13.29,1.98-3.34,0-10.24-.9-13.74-1.98-12.93,8.01-20.84,8.18-31.42,14.75,5.59,9.59,10.01,33.63,10.01,33.63,5.43,25.07,1.33,57.48-.94,75.91-.06.47,3.54,2.27,4,2.27,0,0,11.65.75,16.23,0,2.4-.4,8.94-.02,15.64.25,6.69-.27,13.24-.65,15.63-.25,4.58.75,16.23,0,16.23,0,.47,0,4.06-1.8,4-2.27-2.26-18.42-6.37-50.82-.93-75.89,0-.01,0-.02,0-.02,0,0,4.42-24.04,10.01-33.63,0,0,0,0,0,0Z"
                                    />
                                </g>
                                <g id="SPLIT" *ngIf="jerseyVal(jersey.jerseyType, 'split')">
                                    <g class="st8">
                                        <rect
                                            class="st7"
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'splitColor')"
                                            x="77.83"
                                            y="-7.66"
                                            width="75.24"
                                            height="174.34"
                                        />
                                        <rect
                                            class="st7"
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'splitColor')"
                                            x="77.67"
                                            y="6.75"
                                            width="49.32"
                                            height="137.1"
                                        />
                                    </g>
                                </g>
                                <g
                                    id="VERTIKAL"
                                    *ngIf="
                                        jerseyVal(jersey.jerseyType, 'stripes') ||
                                        jerseyVal(jersey.jerseyType, 'squares')
                                    "
                                >
                                    <g class="st4">
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                            class="st6"
                                            x="32.63"
                                            width="7.56"
                                            height="155.39"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                            class="st6"
                                            x="49.15"
                                            width="7.56"
                                            height="155.39"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                            class="st6"
                                            x="65.66"
                                            width="7.56"
                                            height="155.39"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                            class="st6"
                                            x="82.18"
                                            width="7.56"
                                            height="155.39"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                            class="st6"
                                            x="98.69"
                                            width="7.56"
                                            height="155.39"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'stripesColor')"
                                            class="st6"
                                            x="115.2"
                                            width="7.56"
                                            height="155.39"
                                        />
                                    </g>
                                </g>
                                <g
                                    id="HORIZONTAL"
                                    *ngIf="
                                        jerseyVal(jersey.jerseyType, 'horizontalStripes') ||
                                        jerseyVal(jersey.jerseyType, 'squares')
                                    "
                                >
                                    <g class="st5">
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                            class="st6"
                                            x="73.92"
                                            y="31.26"
                                            width="7.56"
                                            height="155.39"
                                            transform="translate(-31.26 186.65) rotate(-90)"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                            class="st6"
                                            x="73.92"
                                            y="14.75"
                                            width="7.56"
                                            height="155.39"
                                            transform="translate(-14.75 170.15) rotate(-90)"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                            class="st6"
                                            x="73.92"
                                            y="-1.76"
                                            width="7.56"
                                            height="155.39"
                                            transform="translate(1.76 153.64) rotate(-90)"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                            class="st6"
                                            x="73.92"
                                            y="-18.27"
                                            width="7.56"
                                            height="155.39"
                                            transform="translate(18.27 137.13) rotate(-90)"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                            class="st6"
                                            x="73.92"
                                            y="-34.78"
                                            width="7.56"
                                            height="155.39"
                                            transform="translate(34.78 120.62) rotate(-90)"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                            class="st6"
                                            x="73.92"
                                            y="-51.29"
                                            width="7.56"
                                            height="155.39"
                                            transform="translate(51.29 104.11) rotate(-90)"
                                        />
                                        <rect
                                            [style.fill]="jerseyColor(jersey.jerseyType, 'horizontalStripesColor')"
                                            class="st6"
                                            x="73.92"
                                            y="47.77"
                                            width="7.56"
                                            height="155.39"
                                            transform="translate(-47.77 203.16) rotate(-90)"
                                        />
                                    </g>
                                </g>
                                <g id="RUKAVY">
                                    <path
                                        [style.fill]="jerseyColor(jersey.jerseyType, 'sleeve')"
                                        class="st9"
                                        d="M136.29,63.12c-.6-3.9-1.39-9.46-1.97-15.24-.21-2.12-.39-4.27-.53-6.37-.17-2.65-1.05-5.13-2.41-7.4-1.73-2.88-4.23-5.39-7.09-7.43-.55-.39-1.11-.77-1.68-1.13-.1.18-.21.37-.31.56-1.38,2.51-2.68,5.87-3.85,9.48-.94,2.88-1.8,5.93-2.55,8.84-2.03,7.87-3.3,14.75-3.3,14.75,0,0,0,.01,0,.02,0,0,0-.02,0-.02,0,0,.22,1.07.59,2.65.87,3.74,2.53,10.32,3.9,12.29.11.16.22.29.32.39,1.28.11,2.92.12,4.73-.03,2.4-.19,5.09-.65,7.66-1.51.7-.24,1.39-.51,2.07-.81,2-.89,3.84-2.05,5.29-3.59,0,0-.38-2.12-.9-5.46Z"
                                    />
                                    <path
                                        [style.fill]="jerseyColor(jersey.jerseyType, 'sleeve')"
                                        class="st9"
                                        d="M39.47,44.4c-.75-2.91-1.61-5.96-2.55-8.84-1.18-3.62-2.48-6.97-3.85-9.48-.1-.19-.2-.38-.31-.56-.57.36-1.13.74-1.68,1.13-2.85,2.04-5.36,4.55-7.09,7.43-1.36,2.26-2.24,4.75-2.41,7.4-.13,2.11-.32,4.25-.53,6.37-.57,5.78-1.36,11.34-1.97,15.24-.52,3.33-.9,5.46-.9,5.46,1.45,1.53,3.29,2.7,5.29,3.59.68.3,1.37.57,2.07.81,2.57.87,5.26,1.32,7.66,1.51,1.81.14,3.45.14,4.73.03.11-.1.21-.23.32-.39,1.37-1.97,3.03-8.55,3.9-12.29.37-1.58.59-2.65.59-2.65,0,0,0,.02,0,.02,0-.01,0-.02,0-.02,0,0-1.27-6.88-3.3-14.75Z"
                                    />
                                </g>
                                <g id="CISLO">
                                    <text
                                        class="st3"
                                        transform="translate(62.12 66.06)"
                                        [style.fill]="jerseyColor(jersey.jerseyType, 'number')"
                                    >
                                        <tspan x="0" y="0">10</tspan>
                                    </text>
                                </g>
                                <g id="OTVOR">
                                    <path
                                        d="M91.22,10.81s-.04,0-.07,0c-.54.16-5.59,1.61-13.24,1.96-3.34,0-10.24-.9-13.74-1.98h0l-1.33.8c.46,9.72,9.59,15.96,13.3,18.1.97.56,2.15.59,3.14.07,3.62-1.89,12.21-7.48,13.2-18.22-.42-.25-.83-.49-1.27-.75Z"
                                    />
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="d-flex bg-white align-items-center app-form-canvas"
                *ngIf="data?.data?.finished && data!.data!.finished!.length > 0"
            >
                <div class="col">
                    <div *ngIf="loaded" class="text-center p-2 h-100">
                        <app-participant-form [form]="formFiltered | slice: 0 : 10"></app-participant-form>
                    </div>
                </div>
                <div class="col" *ngIf="hasScoredGoalsStats">
                    <iframe
                        *ngIf="calculateScoresPeriodTotal"
                        class="participant-score-iframe"
                        frameborder="0"
                        scrolling="no"
                        [src]="calculateScoresPeriodTotal | safe"
                    ></iframe>
                </div>
            </div>

            <ng-container *ngIf="matchId">
                <app-switchers (onStickyChange)="onStickyChange($event)"></app-switchers>
                <div
                    [class.sticky-parent]="stickyDetail"
                    class="col-right__inner bg-white"
                    *ngIf="matchId"
                    data-cy="right-column-match"
                >
                    <app-match-detail
                        class="sticky-parent__match"
                        data-cy="participant-match-detail"
                        [class.app-match-detail--shadow]="stickyDetail"
                        [style.max-height]="viewPortHeightMatchDetail"
                        [id]="matchId"
                        [matchState]="matchState"
                        [tracker]="tracker"
                        [stream]="stream"
                    ></app-match-detail>
                </div>
            </ng-container>
            <div *ngIf="data?.name && !deviceService.isMobile()" class="d-flex bg-white align-items-center">
                <div class="col">
                    <!-- <app-qa
                        [participants]="[data.name]"
                        [random]="true"
                        [type]="aiParticipantType"
                        [sportName]="sportName"
                        [sportId]="sportId"
                        [tournaments]="uniqueTournaments"
                    ></app-qa> -->
                </div>
            </div>
            <div class="d-flex bg-white align-items-center app-form-canvas" *ngIf="data?.season_stats">
                <div class="col">
                    <hr />
                    <div class="d-flex flex-column">
                        <nav>
                            <ol class="app-small-nav">
                                <li
                                    class="crumb"
                                    *ngFor="
                                        let tournament of data!.season_stats.tournaments | keys;
                                        trackBy: trackByIndex
                                    "
                                >
                                    <a
                                        [routerLink]="['./']"
                                        [queryParams]="{ statsKey: tournament.key }"
                                        class="crumb__link"
                                        [class.active]="
                                            seasonStatsParam === tournament.key ||
                                            (seasonStatsParam === null && tournament.value.tournament_selected)
                                        "
                                        (click)="changeSeasonStatsTournament(tournament.value.tournament_id)"
                                        >{{ tournament.value.tournament_name }}</a
                                    >
                                </li>
                            </ol>
                        </nav>
                        <ng-container>
                            <select
                                class="custom-select border-light2 mb-3"
                                (change)="onSeasonStatsSeasonChange($event)"
                            >
                                <option
                                    *ngFor="let season of getSeasonStatsSeasons() | keys; trackBy: trackByFnSeason"
                                    [value]="season.value.season_id"
                                >
                                    {{ season.value.season_name }}
                                </option>
                            </select>
                        </ng-container>
                        <ng-container *ngIf="getSeasonStatsSelectedSeason().has_subtournaments">
                            <select
                                class="custom-select border-light2 mb-3"
                                (change)="onSeasonStatsSubtournamentChange($event)"
                            >
                                <option
                                    *ngFor="
                                        let subtournament of getSeasonStatsSubtournaments() | keys;
                                        trackBy: trackByFnSubtournament
                                    "
                                    [value]="subtournament.value.subtournament_id"
                                >
                                    {{ subtournament.value.subtournament_name }}
                                </option>
                            </select>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="!statsLoading; else loadingStats">
                        <ng-container
                            *ngIf="
                                this.getSeasonStatsSelectedSeason().has_subtournaments;
                                else seasonStatsWithoutTournament
                            "
                        >
                            <ng-container
                                *ngFor="
                                    let subtournament of this.getSeasonStatsSelectedSeason().subtournaments | keys;
                                    first as isFirst;
                                    trackBy: trackByIndex
                                "
                            >
                                <app-participant-season-stats
                                    *ngIf="
                                        selectedStatsSubtournamentId === subtournament.value.subtournament_id ||
                                        (selectedStatsSubtournamentId === null && isFirst)
                                    "
                                    [sportName]="sportName"
                                    [tournamentName]="this.getSeasonStatsSelectedTournament().tournament_name"
                                    [tournamentCodename]="this.getSeasonStatsSelectedTournament().tournament_codename"
                                    [betradarMajorLeague]="
                                        this.getSeasonStatsSelectedTournament().betradar_major_league
                                    "
                                    [seasonName]="this.getSeasonStatsSelectedSeason().season_name"
                                    [subtournamentName]="subtournament.value.subtournament_name"
                                    [stats]="subtournament.value.statistics"
                                ></app-participant-season-stats>
                            </ng-container>
                        </ng-container>
                        <ng-template #seasonStatsWithoutTournament>
                            <!-- *ngIf="seasonStatsParam === subtournament.key || (seasonStatsParam === null && isFirst) || true"-->
                            <app-participant-season-stats
                                [sportName]="sportName"
                                [tournamentName]="this.getSeasonStatsSelectedTournament().tournament_name"
                                [tournamentCodename]="this.getSeasonStatsSelectedTournament().tournament_codename"
                                [betradarMajorLeague]="this.getSeasonStatsSelectedTournament().betradar_major_league"
                                [seasonName]="this.getSeasonStatsSelectedSeason().season_name"
                                [stats]="this.getSeasonStatsSelectedSeason().statistics ?? {}"
                            ></app-participant-season-stats>
                        </ng-template>
                    </ng-container>
                    <ng-template #loadingStats>
                        <app-page-loader class="app-tracker-loader"></app-page-loader>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <aside class="nav-sports d-none d-xl-block" *ngIf="client.use('sportQuickNav')">
        <nav class="nav flex-column bg-light">
            <app-sport-navigation type="aside" [limit]="asideLimit" [sportId]="sportId"></app-sport-navigation>
            <a
                class="nav-link nav-link--more text-uppercase text-reset"
                [class.nav-link--more]="isAsideDefault()"
                [class.nav-link--less]="!isAsideDefault()"
                (click)="toggleAssideLimit()"
            >
                <span *ngIf="isAsideDefault()">{{ 'web.more' | translate }}</span>
                <span *ngIf="!isAsideDefault()">{{ 'web.less' | translate }}</span>
            </a>
        </nav>
    </aside>
    <aside [class.d-xl-block]="client.use('sportQuickNav')" class="nav-sports nav-sports--extra d-none">
        <nav class="nav flex-column nav-side-menu bg-light">
            <app-side-menu-navigation [sportId]="sportId" [sportName]="sportName"></app-side-menu-navigation>
        </nav>
    </aside>
</div>
